import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1$2 from '@angular/common/http';
import { HttpHeaders, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Inject, EventEmitter, HostListener, Input, Output, Component, HostBinding, forwardRef, Directive, Optional, Pipe, ChangeDetectionStrategy, ViewChild, APP_INITIALIZER, APP_BOOTSTRAP_LISTENER, NgModule } from '@angular/core';
import * as i1$4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i2$1 from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule, BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import * as i1$1 from 'ngx-bootstrap/modal';
import { ModalModule } from 'ngx-bootstrap/modal';
import * as i4 from 'ngx-bootstrap/popover';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
import * as i1 from '@angular/platform-browser';
import { of, lastValueFrom, Observable, Subject } from 'rxjs';
import { retry, map, catchError, switchMap, timeout, filter } from 'rxjs/operators';
import * as i1$3 from '@angular/router';
import { NavigationEnd, ActivationEnd } from '@angular/router';
import * as i1$5 from 'ngx-mask';
import { provideNgxMask } from 'ngx-mask';

/**
 * Objet de stockage de la configuration du module Angular
 *
 * Ne pas utiliser directement CNAF_APP_CONFIG, il faut passer par CnafAppConfigService, c'est plus facile pour faire des tests
 */
let CNAF_APP_CONFIG = {};
/**
 * Service permettant d'accéder à la configuration du module angular chargé à l'initialisation du CnafCommonsModule
 */
class CnafAppConfigService {
    /**
     * Récupère l'objet de configuration globale CnafAppConfigModel
     */
    get cnafAppConfigModel() {
        return CNAF_APP_CONFIG;
    }
    /**
     * Set de l'objet de configuration globale CnafAppConfigModel
     */
    set cnafAppConfigModel(cnafAppConfig) {
        CNAF_APP_CONFIG = cnafAppConfig;
    }
    /**
     * Récupère seulement l'objet userConfig
     */
    getUserConfig() {
        return CNAF_APP_CONFIG.userConfig;
    }
    /**
     * Récupère l'espace ( usager ou partenaire)
     */
    getEspace() {
        return CNAF_APP_CONFIG.espace;
    }
    /**
     * Récupère l'url de redirect suite à la perte de session
     */
    getRedirectDeconnexion() {
        return CNAF_APP_CONFIG.redirectDeconnexion;
    }
    /**
     * Set de l'url de redirect suite à la perte de session
     */
    setRedirectDeconnexion(url) {
        CNAF_APP_CONFIG.redirectDeconnexion = url;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAppConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAppConfigService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAppConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Service permettant de récupérer le contenu de la div pour le NgCnafAide
 */
class NgCnafAideService {
    /**
     * document
     */
    document;
    /**
     * Constructeur
     * @param document: DOCUMENT
     */
    constructor(document) {
        this.document = document;
    }
    /**
     * Fonction qui permet de récupérer l'innerHTML d'une div à partir de son id
     * @param idDiv: string
     */
    getElementById(idDiv) {
        if (this.document.getElementById(idDiv)) {
            return this.document.getElementById(idDiv).innerHTML;
        }
        return '';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafAideService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafAideService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafAideService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

/**
 * Composant de bulle d'aide</br>
 * [Documentation - showcase](http://docweb.intra.cnaf/edenangular/components/#champSaisieTexteAide)
 */
class NgCnafAideComponent {
    sanitizer;
    cnafAppConfigService;
    cnafAideService;
    /**
     * idDiv contenant la popup à afficher
     */
    idDiv;
    /**
     * Balise alt - obligatoire pour l'accessibilité
     */
    alt;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @angular-eslint/no-output-on-prefix
    onOpen = new EventEmitter();
    /**
     * Src par défaut de l'image aide grisé
     */
    imgSrcHide; // = '/icfstatiquesangularappli/dist/images/pic_aide_gris.png';
    /**
     * Src de l'image quand bulle d'aide activé
     */
    imgSrcShow;
    /**
     * HTML sanitized pour afficher la popup
     */
    htmlSanitized;
    /**
     * Src par défaut de l'image aide grisé
     */
    imgSrc = '/icfstatiquesangularappli/dist/images/pic_aide_gris.png';
    htmlCroix = '<div class="popover-btn-close-cnaf" (click)="pop.hide();isOpen=false;"></div>';
    /**
     * Attribut qui permet d'ouvrir la popup à partir du controller
     */
    isOpen = false;
    constructor(sanitizer, cnafAppConfigService, cnafAideService) {
        this.sanitizer = sanitizer;
        this.cnafAppConfigService = cnafAppConfigService;
        this.cnafAideService = cnafAideService;
    }
    /**
     * ngAfterViewInit
     */
    ngAfterViewInit() {
        setTimeout(() => {
            this.htmlSanitized = this.sanitizer.bypassSecurityTrustHtml(this.htmlCroix + this.cnafAideService.getElementById(this.idDiv));
            if (!this.imgSrcHide) {
                this.imgSrcHide = '/icfstatiquesangularappli/dist/images/pic_aide_gris.png';
            }
            this.imgSrc = this.imgSrcHide;
            if (!this.imgSrcShow) {
                this.imgSrcShow = '/icfstatiquesangularappli/dist/images/' + this.cnafAppConfigService.getEspace() + '/pic_aide.png';
            }
            if (!this.alt) {
                this.alt = 'Information supplémentaire';
            }
        });
    }
    /**
     * Fonction qui permet d'ouvrir la popup avec les touche Entrer et Espace </br>
     * Et fermer la popup avec Echap
     * @param event KeyboardEvent
     */
    onKeyUpHandler(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            this.isOpen = !this.isOpen;
        }
        else if (event.key === 'Escape') {
            this.isOpen = false;
        }
    }
    /**
     * Fonction appelée au click sur le bouton aide
     */
    clickAide(event) {
        // Le preventDefault est utile quand le ngCnafAide dans un ngIf avec un label for,
        // car au réaffichage, l'event sur le label avec le for prend le dessus sur le click du cnaf-aide
        event.preventDefault();
        this.isOpen = !this.isOpen;
    }
    /**
     * Fonction appelée lors de l'ouverture de la popover
     *
     * @param event: Event
     */
    onShown(event) {
        this.onOpen.emit(event);
    }
    /**
     * Fonction appelée à la prise de Focus
     */
    onFocus() {
        this.imgSrc = this.imgSrcShow;
    }
    /**
     * Fonction appelée à la perte de focus
     */
    onFocusOut() {
        this.imgSrc = this.imgSrcHide; //'/icfstatiquesangularappli/dist/images/pic_aide_gris.png';
        this.isOpen = false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafAideComponent, deps: [{ token: i1.DomSanitizer }, { token: CnafAppConfigService }, { token: NgCnafAideService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafAideComponent, selector: "ng-cnaf-aide", inputs: { idDiv: "idDiv", alt: "alt", imgSrcHide: "imgSrcHide", imgSrcShow: "imgSrcShow" }, outputs: { onOpen: "onOpen" }, host: { listeners: { "keyup": "onKeyUpHandler($event)" } }, ngImport: i0, template: "<ng-template #popContent>\n  <div id=\"divContentPopover\" [innerHtml]=\"htmlSanitized\"></div>\n</ng-template>\n\n<a\n  tabindex=\"0\"\n  class=\"btn btn-info ng-popover-button-cnaf\"\n  role=\"button\"\n  #pop=\"bs-popover\"\n  data-container=\"body\"\n  data-trigger=\"manual\"\n  [popover]=\"popContent\"\n  [outsideClick]=\"true\"\n  [isOpen]=\"isOpen\"\n  (click)=\"clickAide($event)\"\n  (focus)=\"onFocus()\"\n  (focusout)=\"onFocusOut()\"\n  (onShown)=\"onShown($event)\"\n  triggers=\"\"\n  placement=\"right\"\n>\n  <img [src]=\"imgSrc\" [alt]=\"alt\" />\n</a>\n", styles: ["#divContentPopover{margin-top:15px;margin-right:15px}:host-context(.label-form-cnaf) .btn{margin-top:-10px;margin-bottom:-10px}\n"], dependencies: [{ kind: "directive", type: i4.PopoverDirective, selector: "[popover]", inputs: ["adaptivePosition", "boundariesElement", "popover", "popoverContext", "popoverTitle", "placement", "outsideClick", "triggers", "container", "containerClass", "isOpen", "delay"], outputs: ["onShown", "onHidden"], exportAs: ["bs-popover"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafAideComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ng-cnaf-aide', template: "<ng-template #popContent>\n  <div id=\"divContentPopover\" [innerHtml]=\"htmlSanitized\"></div>\n</ng-template>\n\n<a\n  tabindex=\"0\"\n  class=\"btn btn-info ng-popover-button-cnaf\"\n  role=\"button\"\n  #pop=\"bs-popover\"\n  data-container=\"body\"\n  data-trigger=\"manual\"\n  [popover]=\"popContent\"\n  [outsideClick]=\"true\"\n  [isOpen]=\"isOpen\"\n  (click)=\"clickAide($event)\"\n  (focus)=\"onFocus()\"\n  (focusout)=\"onFocusOut()\"\n  (onShown)=\"onShown($event)\"\n  triggers=\"\"\n  placement=\"right\"\n>\n  <img [src]=\"imgSrc\" [alt]=\"alt\" />\n</a>\n", styles: ["#divContentPopover{margin-top:15px;margin-right:15px}:host-context(.label-form-cnaf) .btn{margin-top:-10px;margin-bottom:-10px}\n"] }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }, { type: CnafAppConfigService }, { type: NgCnafAideService }], propDecorators: { idDiv: [{
                type: Input
            }], alt: [{
                type: Input
            }], onOpen: [{
                type: Output
            }], imgSrcHide: [{
                type: Input
            }], imgSrcShow: [{
                type: Input
            }], onKeyUpHandler: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

/**
 * Composant barre d'étape
 * [Documentation - showcase](http://docweb.intra.cnaf/edenangular/components/#component-barre-etape)
 */
class NgCnafBarreEtapeComponent {
    cnafAppConfigService;
    /**
     * Ajout classe 'theme-partenaire' si on est dans l'espace partenaire ( sert à positionner les bonnes couleurs )
     */
    isThemePartenaire;
    /**
     * Liste des étapes
     */
    steps;
    /**
     * Etape active
     */
    stepActive;
    /**
     * Taille de div invisible
     */
    widthInvisible;
    /**
     * styleCss appliqué sur la barre d'étape dans le template
     */
    styleBarre = null;
    /**
     * Constructeur
     * @param cnafAppConfigService: CnafAppConfigService
     */
    constructor(cnafAppConfigService) {
        this.cnafAppConfigService = cnafAppConfigService;
        this.isThemePartenaire = this.cnafAppConfigService.getEspace() === 'partenaire';
    }
    /**
     * ngAfterViewInit - Appel du pageReadyForTheme pour appliquer du style à la barre d'étape après son affichage
     */
    ngAfterViewInit() {
        setTimeout(() => {
            pageReadyForTheme();
        }, 100);
    }
    /**
     * ngOnInit - Init de la taille
     */
    ngOnInit() {
        if (this.widthInvisible) {
            this.styleBarre = { width: this.widthInvisible };
        }
    }
    /**
     * Permet de savoir si l'étape est active
     * @param libStep étape
     */
    isActive(libStep) {
        return this.stepActive === libStep ? 'active' : 'inactive';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafBarreEtapeComponent, deps: [{ token: CnafAppConfigService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: NgCnafBarreEtapeComponent, selector: "ng-cnaf-barre-etape", inputs: { steps: "steps", stepActive: "stepActive", widthInvisible: "widthInvisible" }, host: { properties: { "class.theme-partenaire": "this.isThemePartenaire" } }, ngImport: i0, template: "<ol class=\"barre-etape-cnaf\">\n  @for (step of steps; track step; let i = $index) {\n    <li [ngClass]=\"isActive(step)\">\n      @if (isActive(step) === \"active\") {\n        <span class=\"sr-only\">\u2013 \u00E9tape active</span>\n      }\n      <span class=\"etape-indicateur-cnaf\">{{ i + 1 }}</span>\n      <span class=\"etape-nom-cnaf d-none d-md-block hidden-xs hidden-sm\">{{ step }}</span>\n      <span class=\"etape-nom-cnaf d-md-none visible-xs visible-sm\">&nbsp;</span>\n      <span class=\"etape-etat-cnaf\"></span>\n    </li>\n  }\n  <li class=\"barre-etape-information-cnaf hidden-xs d-none d-sm-block invisible\" [ngStyle]=\"styleBarre\"></li>\n</ol>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafBarreEtapeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ng-cnaf-barre-etape', template: "<ol class=\"barre-etape-cnaf\">\n  @for (step of steps; track step; let i = $index) {\n    <li [ngClass]=\"isActive(step)\">\n      @if (isActive(step) === \"active\") {\n        <span class=\"sr-only\">\u2013 \u00E9tape active</span>\n      }\n      <span class=\"etape-indicateur-cnaf\">{{ i + 1 }}</span>\n      <span class=\"etape-nom-cnaf d-none d-md-block hidden-xs hidden-sm\">{{ step }}</span>\n      <span class=\"etape-nom-cnaf d-md-none visible-xs visible-sm\">&nbsp;</span>\n      <span class=\"etape-etat-cnaf\"></span>\n    </li>\n  }\n  <li class=\"barre-etape-information-cnaf hidden-xs d-none d-sm-block invisible\" [ngStyle]=\"styleBarre\"></li>\n</ol>\n" }]
        }], ctorParameters: () => [{ type: CnafAppConfigService }], propDecorators: { isThemePartenaire: [{
                type: HostBinding,
                args: ['class.theme-partenaire']
            }], steps: [{
                type: Input
            }], stepActive: [{
                type: Input
            }], widthInvisible: [{
                type: Input
            }] } });

/**
 * Composant Checkbox
 * [Documentation - showcase](http://docweb.intra.cnaf/edenangular/components/#checkbox-cac)
 */
class NgCnafCheckboxComponent {
    isDisabled = false;
    /**
     * Attribut name de la checkbox
     */
    name;
    /**
     * Attribut labelelledby positionné sur le button
     */
    ariaLabelledby;
    /**
     * boolean de sélection de la checkbox
     */
    isSelected;
    /**
     * Type fonction onChange, prend en paramètre un boolean
     */
    #onChange = (value) => {
        value;
    };
    /**
     * Type fonction onTouched
     */
    #onTouched = () => { };
    /**
     * Fonction writeValue de ControlValueAccessor
     */
    writeValue(obj) {
        this.isSelected = obj;
    }
    /**
     * Fonction registerOnChange de ControlValueAccessor
     */
    registerOnChange(fn = this.#onChange) {
        this.#onChange = fn;
    }
    /**
     * Fonction registerOnTouched de ControlValueAccessor
     */
    registerOnTouched(fn = this.#onTouched) {
        this.#onTouched = fn;
    }
    /**
     * Fonction isDisabled de ControlValueAccessor
     * @param isDisabled isDisabled
     */
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    /**
     * Fonction appelé lors du clic sur la checkbox
     */
    click() {
        this.isSelected = !this.isSelected;
        this.#onChange(this.isSelected);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafCheckboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafCheckboxComponent, selector: "ng-cnaf-checkbox", inputs: { name: "name", ariaLabelledby: ["aria-labelledby", "ariaLabelledby"] }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NgCnafCheckboxComponent),
                multi: true
            }
        ], ngImport: i0, template: "<button\n  type=\"button\"\n  [id]=\"name\"\n  class=\"btn btn-default cnaf-checkbox\"\n  class=\"btn btn-default cnaf-checkbox btn-xs\"\n  role=\"checkbox\"\n  (click)=\"click()\"\n  attr.aria-checked=\"{{ isSelected }}\"\n  attr.aria-labelledby=\"{{ ariaLabelledby }}\"\n  [disabled]=\"isDisabled\"\n>\n  <span data-ng-style=\"styleicon\" class=\"glyphicon\" [ngClass]=\"{ 'glyphicon-ok': isSelected }\"></span>\n</button>\n", styles: ["span{width:10px;left:-1px}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ng-cnaf-checkbox', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => NgCnafCheckboxComponent),
                            multi: true
                        }
                    ], template: "<button\n  type=\"button\"\n  [id]=\"name\"\n  class=\"btn btn-default cnaf-checkbox\"\n  class=\"btn btn-default cnaf-checkbox btn-xs\"\n  role=\"checkbox\"\n  (click)=\"click()\"\n  attr.aria-checked=\"{{ isSelected }}\"\n  attr.aria-labelledby=\"{{ ariaLabelledby }}\"\n  [disabled]=\"isDisabled\"\n>\n  <span data-ng-style=\"styleicon\" class=\"glyphicon\" [ngClass]=\"{ 'glyphicon-ok': isSelected }\"></span>\n</button>\n", styles: ["span{width:10px;left:-1px}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }], ariaLabelledby: [{
                type: Input,
                args: ['aria-labelledby']
            }] } });

/**
 * Model de l'objet CnafToken
 */
var CnafScopeToken;
(function (CnafScopeToken) {
    CnafScopeToken["Usagers"] = "usagers";
    CnafScopeToken["Partenaires"] = "partenaires";
    CnafScopeToken["Public"] = "public";
})(CnafScopeToken || (CnafScopeToken = {}));

/**
 * Modal avertissant que la session a expirée
 */
class NgCnafModalSessionDeadComponent {
    bsModalRef;
    cnafAppConfigService;
    /**
     * Constructeur
     * @param bsModalRef: BsModalRef
     * @param cnafAppConfigService: CnafAppConfigService
     */
    constructor(bsModalRef, cnafAppConfigService) {
        this.bsModalRef = bsModalRef;
        this.cnafAppConfigService = cnafAppConfigService;
    }
    /**
     * Fonction appelée au click du bouton Accueil
     */
    clickAccueil() {
        // Fermeture de la modal
        this.bsModalRef.hide();
        // Retour à la page de reconnexion
        this.navigateToUrl(this.cnafAppConfigService.getRedirectDeconnexion());
    }
    /**
     * Navigation à l'url
     * @param url; string
     * @private
     */
    navigateToUrl(url) {
        window.location.href = url;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafModalSessionDeadComponent, deps: [{ token: i1$1.BsModalRef }, { token: CnafAppConfigService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafModalSessionDeadComponent, selector: "ng-cnaf-modal-session-dead", ngImport: i0, template: "    <div class=\"modal-header\">    <div role=\"heading\" aria-level=\"1\" class=\"texte-medium text-primary\" id=\"sessionModalDead\">Votre session a expir\u00E9.</div>    </div>    <div class=\"modal-body\">        <div class=\"row \">         <div class=\"col-sm-12\">           <p id=\"desc\">              Vous devez vous connecter \u00E0 nouveau pour Continuer.              </p>              <div class=\"float-end pull-right\">                <button type=\"button\" class=\"btn btn-form-cnaf btn-majeur-cnaf\" (click)=\"clickAccueil()\" data-dismiss=\"modal\" data-bs-dismiss=\"modal\" aria-describedby=\"desc\" autofocus>Continuer</button>            </div>         </div>     </div>    </div>", isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafModalSessionDeadComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ng-cnaf-modal-session-dead',
                    template: '    <div class="modal-header">' +
                        '    <div role="heading" aria-level="1" class="texte-medium text-primary" id="sessionModalDead">Votre session a expiré.</div>' +
                        '    </div>' +
                        '    <div class="modal-body">' +
                        '        <div class="row ">' +
                        '         <div class="col-sm-12">' +
                        '           <p id="desc">' +
                        '              Vous devez vous connecter à nouveau pour Continuer. ' +
                        '             </p>' +
                        '              <div class="float-end pull-right">' +
                        '                <button type="button" class="btn btn-form-cnaf btn-majeur-cnaf" (click)="clickAccueil()" data-dismiss="modal" data-bs-dismiss="modal" aria-describedby="desc" autofocus>Continuer</button>' +
                        '            </div>' +
                        '         </div>' +
                        '     </div>' +
                        '    </div>'
                }]
        }], ctorParameters: () => [{ type: i1$1.BsModalRef }, { type: CnafAppConfigService }] });

/**
 * Permet la gestion du tokenJWT dans le contexte CNAF
 */
class CnafTokenService {
    http;
    cnafAppConfigService;
    modalService;
    /**
     * Date du client de régénération du token ( date client peut être différente de la date serveur en JS )
     */
    dateClientToken;
    /**
     * Url permettant de regénérer le token
     */
    #urlServletJwt;
    /**
     * Offset permettant le controle de valité du token
     */
    offsetTokenTimeValidity = 15;
    /**
     * Durée de validité du token
     */
    tokenTimeValidity;
    /**
     * TokenJWT en cours
     */
    #tokenJWT;
    /**
     * Evénement déclenché lors du refresh du token
     * @private
     */
    eventRefreshToken = new EventEmitter();
    /**
     * Configuration de la modal d'expiration de session
     */
    CONFIG_MODAL = {
        backdrop: true,
        ignoreBackdropClick: true
    };
    constructor(http, cnafAppConfigService, modalService) {
        this.http = http;
        this.cnafAppConfigService = cnafAppConfigService;
        this.modalService = modalService;
        const cnafAppConfig = this.cnafAppConfigService.cnafAppConfigModel;
        this.#urlServletJwt = cnafAppConfig.urlServletJwt;
        this.offsetTokenTimeValidity = cnafAppConfig.offsetTokenTimeValidity;
        if (cnafAppConfig.tokenJWT) {
            this.tokenJWT = cnafAppConfig.tokenJWT;
        }
    }
    /**
     * set tokenJWT
     * init aussi dateClientToken à la date du navigateur si token différent
     */
    set tokenJWT(token) {
        if (token !== this.#tokenJWT) {
            this.dateClientToken = new Date();
            this.eventRefreshToken.emit();
        }
        this.#tokenJWT = token;
    }
    /**
     * get tokenJWT()
     */
    get tokenJWT() {
        return this.#tokenJWT;
    }
    /**
     * get urlServletJwt
     */
    get urlServletJwt() {
        return this.#urlServletJwt;
    }
    /**
     * set urlServletJwt
     */
    set urlServletJwt(url) {
        this.#urlServletJwt = url;
    }
    /**
     * Get Token Observable
     * @return Observable permettant de générer un token
     */
    getTokenJWTObservable() {
        return this.http.get(this.urlServletJwt).pipe(retry(1), map((cnafToken) => {
            if (this.isCnafToken(cnafToken)) {
                return cnafToken.cnafTokenJwt;
            }
            else if (this.isCnafTokenPartenaire(cnafToken)) {
                return cnafToken.access_token;
            }
            return '';
        }), catchError((err) => {
            this.openModalPerteSession();
            if (!this.urlServletJwt) {
                throw new Error('Erreur de génération du token - propriété urlServletJwt non définie : ' + err.message);
            }
            else {
                throw new Error('Erreur de génération du token : ' + err.message);
            }
        }));
    }
    isCnafToken(value) {
        return value.cnafTokenJwt !== undefined;
    }
    isCnafTokenPartenaire(value) {
        return value.access_token !== undefined;
    }
    /**
     * Permet d'obtenir un token valide
     *
     * Si token en cours expiré, regénération d'un token
     *
     *
     * @return Observable
     */
    getJWT() {
        let tokenJWTObservable;
        // Vérif si le token est sur le point d'expirer par rapport au délais voulu
        if (!this.#tokenJWT || this.isTokenExpired(this.#tokenJWT, this.offsetTokenTimeValidity)) {
            // Regénération du token
            tokenJWTObservable = this.getTokenJWTObservable();
        }
        else {
            // Utilisation du token existant
            tokenJWTObservable = of(this.#tokenJWT);
        }
        return tokenJWTObservable;
    }
    /**
     * Decodage base64
     * @param str string en base64
     * @return string décodé
     */
    urlBase64Decode(str) {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: {
                break;
            }
            case 2: {
                output += '==';
                break;
            }
            case 3: {
                output += '=';
                break;
            }
            default: {
                throw new Error('Illegal base64url string!');
            }
        }
        return this.b64DecodeUnicode(output);
    }
    /**
     * Decodage base64
     *
     * // credits for decoder goes to https://github.com/atk
     * @param str string en base64
     * @return string décodé
     */
    b64decode(str) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output = '';
        str = String(str).replace(/=+$/, '');
        if (str.length % 4 === 1) {
            throw new Error("'atob' failed: The string to be " + 'decoded is not correctly encoded.');
        }
        for (
        // initialize result and counters
        let bc = 0, bs = 0, buffer, idx = 0; 
        // get next character
        // eslint-disable-next-line no-cond-assign
        (buffer = str.charAt(idx++)); 
        // character found in table? initialize bit storage and add its ascii value;
        // eslint-disable-next-line no-bitwise
        ~buffer &&
            // eslint-disable-next-line no-cond-assign
            ((bs = bc % 4 ? bs * 64 + buffer : buffer),
                // and if not first of each 4 characters,
                // convert the first 8 bits to one ascii character
                bc++ % 4)
            ? // eslint-disable-next-line no-bitwise
                (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
            : 0) {
            // try to find character in table (0-63, not found => -1)
            buffer = chars.indexOf(buffer);
        }
        return output;
    }
    /**
     * b64DecodeUnicode
     * @param str string base64
     */
    b64DecodeUnicode(str) {
        return decodeURIComponent(Array.prototype.map
            .call(this.b64decode(str), (c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
    }
    /**
     * Permet de décoder le token
     * @param token token en base64
     * @return token décodé
     */
    decodeToken(token) {
        if (token === null || token === '') {
            return null;
        }
        const parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error("The inspected token doesn't appear to be a JWT." + 'Check to make sure it has three parts and see https://jwt.io for more.');
        }
        const decoded = this.urlBase64Decode(parts[1]);
        if (!decoded) {
            throw new Error('Cannot decode the token.');
        }
        return JSON.parse(decoded);
    }
    /**
     * Permet d'obtenir la date d'expiration du token
     * @param decodedToken token décodé
     * @return Date d'expiration du token
     */
    getTokenExpirationDate(decodedToken) {
        if (!decodedToken.hasOwnProperty('exp')) {
            return null;
        }
        const date = new Date(0);
        // Timepstamp en milliseconds, on divise par 1000
        if (decodedToken.exp > 99999999999) {
            date.setUTCSeconds(decodedToken.exp / 1000);
        }
        else {
            // Timepstamp en seconds
            date.setUTCSeconds(decodedToken.exp);
        }
        return date;
    }
    /**
     * Permet le scope contenu dans le Token
     * @param decodedToken token décodé
     * @return CnafScopeToken scope du token
     */
    getTokenScope(decodedToken) {
        if (!decodedToken.hasOwnProperty('scope')) {
            return null;
        }
        return decodedToken.scope;
    }
    /**
     * Permet de savoir si le token est expiré
     *
     * Pour savoir si un token expire, on utilise la dateJS du navigateur du client, à chaque renouvellement
     * du token, on stoke la dateClientToken ( date de regénération du token ) et on regarde si cette date soustraite
     * à la date actuelleest supérieur au temps de validité du token (moins l'offetSeconds), si oui le token est expiré
     * si non, le token est encore valide
     *
     * L'offsetSeconds permet de se garder une marge sur la validité du token, cela permet d'avoir
     * un token valide pour les traitements des API qui peuvent durer
     * @param token token
     * @param offsetSeconds offset en seconde pour la comparaison des dates de validité
     * @return validité du token
     */
    isTokenExpired(token, offsetSeconds) {
        if (token) {
            const dateActuelle = new Date();
            // Temps depuis la création du token en fonction de la date JS client
            const deltaDateJS = dateActuelle.valueOf() - this.dateClientToken.valueOf();
            // On vérifie que cette date est inférieur à la durée d'expiration du token - offset
            // eslint-disable-next-line prettier/prettier
            return deltaDateJS > this.getTokenTimeValidy(token) - (offsetSeconds * 1000);
        }
        return true;
    }
    /**
     * Retourne la date de création du token
     * @param decodedToken token décodé
     * @return date de création du token
     */
    getTokenCreationDate(decodedToken) {
        if (!decodedToken.hasOwnProperty('iat')) {
            return null;
        }
        const d = new Date(0); // The 0 here is the key, which sets the date to the epoch
        // Timepstamp en milliseconds, on divise par 1000
        if (decodedToken.iat > 99999999999) {
            d.setUTCSeconds(decodedToken.iat / 1000);
        }
        else {
            // Timepstamp en seconds
            d.setUTCSeconds(decodedToken.iat);
        }
        return d;
    }
    /**
     * Retourne la durée de validité du token
     * @param token token
     * @return durée de validité du token
     */
    getTokenTimeValidy(token) {
        if (!this.tokenTimeValidity) {
            const decoded = this.decodeToken(token);
            // @ts-expect-error refacto
            this.tokenTimeValidity = this.getTokenExpirationDate(decoded).valueOf() - this.getTokenCreationDate(decoded).valueOf();
        }
        return this.tokenTimeValidity;
    }
    /**
     * Retourne la propriété contenue dans le token qui correspond à la clé passé en paramètre
     * @param token token
     * @return propriété ( null si non trouvé )
     */
    getTokenPropertie(key) {
        if (this.tokenJWT) {
            const decoded = this.decodeToken(this.tokenJWT);
            if (decoded.hasOwnProperty(key)) {
                return decoded[key];
            }
        }
        return '';
    }
    /**
     * Fonction qui ouvre une modal si perte de session
     */
    openModalPerteSession() {
        this.modalService.show(NgCnafModalSessionDeadComponent, this.CONFIG_MODAL);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafTokenService, deps: [{ token: i1$2.HttpClient }, { token: CnafAppConfigService }, { token: i1$1.BsModalService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafTokenService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafTokenService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$2.HttpClient }, { type: CnafAppConfigService }, { type: i1$1.BsModalService }] });

/**
 * Service de marquage AT-Internet
 */
class CnafAtTagService {
    cnafTokenService;
    S_ERROR_MESSAGE = "CnafAtTagService : Objet Tag undefined - Vérifier la présence de l'import";
    /**
     * Objet tag ATInternet.Tracker
     */
    #tag;
    /**
     * Id Site pour l'objet TAG
     */
    #site;
    /**
     * Constructeur
     */
    constructor(cnafTokenService) {
        this.cnafTokenService = cnafTokenService;
        if (typeof ATInternet !== 'undefined') {
            this.tag = new ATInternet.Tracker.Tag();
        }
    }
    /**
     * Modification du site de l'objet Tag d'AtInternet
     * Il n'est pas nécessaire de refaire le changement de site à chaque nouvel envoie de stat
     * Le changement de site se fait de façon global
     */
    set site(site) {
        this.#site = site;
        try {
            if (this.tag !== undefined) {
                this.tag.setConfig('site', site, false);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    get site() {
        return this.#site;
    }
    get tag() {
        if (this.#tag) {
            return this.#tag;
        }
        else {
            throw new Error();
        }
    }
    set tag(code) {
        this.#tag = code;
    }
    /**
     * Mesure de clic standard ( appel de tag.clicl.send )
     */
    click(info) {
        try {
            return this.tag.click.send(info);
        }
        catch (e) {
            console.error(e);
        }
        return false;
    }
    /**
     * Mesure de clic avec listener ( appel de tag.clickListener.send)
     */
    clickListener(info) {
        try {
            this.tag.clickListener.send(info);
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Mesure de page ( appel de tag.dispatch )
     * Ajout également dans le tag de l'objet customVars
     * <b>Attention : </b> S'il n'y a pas de token ou que le scope est public, l'identifiedVisitor est unset de l'objet Tag
     */
    pageSend(info) {
        try {
            //reinit du tag
            this.tag.page.reset();
            this.tag.delProps();
            // Set du site dans le tag s'il y a eu modification de celui-ci
            if (this.site) {
                this.tag.setConfig('site', this.site, false);
            }
            // Pour ne pas modifier l'objet en paramètre on fait un clone
            const oInfo = Object.assign({}, info);
            // Set identifiedVisitor
            if (info.identifiedVisitor) {
                this.tag.identifiedVisitor.set(info.identifiedVisitor);
                delete oInfo.identifiedVisitor;
            }
            // Si pas de token ou token avec un scope public, on supprime l'identifiedVisitor
            if (!this.cnafTokenService.tokenJWT ||
                this.cnafTokenService.getTokenScope(this.cnafTokenService.decodeToken(this.cnafTokenService.tokenJWT)) === CnafScopeToken.Public) {
                this.tag.identifiedVisitor.unset();
            }
            // Ajout information customVars et suppression de l'objet PageInfo
            if (oInfo.customVars) {
                this.tag.customVars.set(oInfo.customVars);
                delete oInfo.customVars;
            }
            // Ajout information customPropsPersistent
            if (oInfo.customPropsPersistent) {
                this.tag.setProps(oInfo.customPropsPersistent, true);
                delete oInfo.customPropsPersistent;
            }
            // Ajout information customPropsPersistent
            if (oInfo.customPropsNonPersistent) {
                this.tag.setProps(oInfo.customPropsNonPersistent, false);
                delete oInfo.customPropsNonPersistent;
            }
            this.tag.page.set(oInfo);
            this.tag.dispatch();
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Mesure publisher ( appel de tag.publisher.send)
     * Exemple : impression
     */
    publisherSend(publisher) {
        try {
            return this.tag.publisher.send(publisher);
        }
        catch (e) {
            console.error(e);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAtTagService, deps: [{ token: CnafTokenService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAtTagService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAtTagService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CnafTokenService }] });

/**
 * Directive de marquage At-Internet
 **/
class NgCnafAtTagDirective {
    el;
    tagService;
    /**
     * Constructeur
     * @param el: ElementRef
     * @param tagService: TagService
     */
    constructor(el, tagService) {
        this.el = el;
        this.tagService = tagService;
    }
    /**
     * clickData: ClickInfo
     */
    clickData;
    /**
     * pageData: PageInfo
     */
    pageData;
    /**
     * publisherData: {}
     */
    publisherData;
    /**
     * ngAfterViewInit
     */
    ngAfterViewInit() {
        if (this.pageData) {
            this.tagService.pageSend(this.pageData);
        }
        else if (this.clickData) {
            this.clickData.elem = this.el.nativeElement;
            this.tagService.clickListener(this.clickData);
        }
        else if (this.publisherData) {
            this.tagService.publisherSend(this.publisherData);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafAtTagDirective, deps: [{ token: i0.ElementRef }, { token: CnafAtTagService }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafAtTagDirective, selector: "[ngCnafAtTag]", inputs: { clickData: "clickData", pageData: "pageData", publisherData: "publisherData" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafAtTagDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngCnafAtTag]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CnafAtTagService }], propDecorators: { clickData: [{
                type: Input
            }], pageData: [{
                type: Input
            }], publisherData: [{
                type: Input
            }] } });

/**
 * Directive de positionnement du focus
 */
class NgCnafFocusDirective {
    element;
    /**
     * Booleen. Permet de positionner le focus si true.
     **/
    isFocused;
    /**
     * Notifie les changement de valeur de ngCnafFocus.
     **/
    ngCnafFocusChange = new EventEmitter();
    /**
     * Listenner du blur. Remet la condition du focus à false.
     */
    onBlur() {
        this.isFocused = false;
        this.ngCnafFocusChange.emit(false);
    }
    /**
     * Constructeur
     * @param element: ElementRef<HTMLElement>
     */
    constructor(element) {
        this.element = element;
    }
    /**
     * Positionne le focus sur l'element HTML.
     */
    focusElement() {
        if (this.isFocused) {
            setTimeout(() => this.element.nativeElement.focus(), 0);
        }
    }
    /**
     * ngOnChanges. Positionne le focus si la condition du ngCnafFocus est modifiee.
     */
    ngOnChanges() {
        this.focusElement();
    }
    /**
     * ngOnInit. Positionne le focus au premier affichage.
     */
    ngOnInit() {
        this.focusElement();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafFocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafFocusDirective, selector: "[ngCnafFocus]", inputs: { isFocused: ["ngCnafFocus", "isFocused"] }, outputs: { ngCnafFocusChange: "ngCnafFocusChange" }, host: { listeners: { "blur": "onBlur()" } }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafFocusDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[ngCnafFocus]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { isFocused: [{
                type: Input,
                args: ['ngCnafFocus']
            }], ngCnafFocusChange: [{
                type: Output
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

/**
 * Service qui permet de charger la configuration du module angular
 * (token, offsetTokenTimeValidity, urlServletJwt) à partir de variables JS Globales</br>
 * Structure de la variable :</br>
@example
  var mapForAngularAppli={};
  mapForAngularAppli.appConfig={};
  mapForAngularAppli.appConfig.offsetTokenTimeValidity=15;
    mapForAngularAppli.appConfig.urlServletJWT="/wta-portletangular-web/s/GenerateTokenJwt/";
    mapForAngularAppli.appConfig.tokenJWT="";
    mapForAngularAppli.userConfig={
                      'codeOrga':'456',
                      'matricule':'46',
                      'dateEnvCaffr':'dateenv',
                      'listGroups':['groupe1','groupe2'],
                      'CNAF_LIST_GROUP':
                      {
                          'GROUPE_1':'groupe1',
                          'GROUPE_2':'groupe2'
                      }
                };
    mapForAngularAppli.espace = 'partenaire';
    mapForAngularAppli.redirectDeconnexion = '/urlRedirect';
 */
class CnafAppConfigLoaderService {
    /**
     * Permet de charger la configuration du module angular
     */
    async getConfigs() {
        return lastValueFrom(new Observable((observer) => {
            // @ts-expect-error pas de type
            const mapForAngularAppli = window['mapForAngularAppli'];
            CNAF_APP_CONFIG.userConfig = mapForAngularAppli.userConfig;
            if (mapForAngularAppli.appConfig) {
                if (mapForAngularAppli.appConfig.offsetTokenTimeValidity) {
                    CNAF_APP_CONFIG.offsetTokenTimeValidity = mapForAngularAppli.appConfig.offsetTokenTimeValidity;
                }
                else {
                    CNAF_APP_CONFIG.offsetTokenTimeValidity = 15;
                }
                if (mapForAngularAppli.appConfig.urlServletJWT) {
                    CNAF_APP_CONFIG.urlServletJwt = mapForAngularAppli.appConfig.urlServletJWT;
                }
                else {
                    CNAF_APP_CONFIG.urlServletJwt = '/wta-portletangular-web/s/GenerateTokenJwt/';
                }
                CNAF_APP_CONFIG.tokenJWT = mapForAngularAppli.appConfig.tokenJWT;
            }
            // Récupération de l'espace - Par défaut, espace usager
            if (mapForAngularAppli.espace) {
                CNAF_APP_CONFIG.espace = mapForAngularAppli.espace;
            }
            else {
                CNAF_APP_CONFIG.espace = 'usager';
            }
            // Récupération de l'url de redirect suite à la perte de session
            CNAF_APP_CONFIG.redirectDeconnexion = mapForAngularAppli.redirectDeconnexion;
            observer.next(CNAF_APP_CONFIG);
            observer.complete();
        }));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAppConfigLoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAppConfigLoaderService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafAppConfigLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * TimeOut par défaut HTTP
 */
const DEFAULT_TIMEOUT = 60000;
/**
 * Service permettant d'ajouter le token CNAF lors des appels d'API
 */
class CnafTokenInterceptor {
    inj;
    /**
     * Constructeur par défaut
     */
    constructor(inj) {
        this.inj = inj;
    }
    /**
     * Intercepteur HTTP
     */
    intercept(request, next) {
        // const timeout = defaultTimeout;
        if (request && request.url.match('^/api/')) {
            // we have to return this block which after the flatMap operator will return the next.handle(request)
            return this.inj
                .get(CnafTokenService)
                .getJWT()
                .pipe(switchMap((token) => {
                if (token.indexOf('Bearer') === -1) {
                    token = 'Bearer ' + token;
                }
                // we use the output from your tokenRequest to clone the current request
                this.inj.get(CnafTokenService).tokenJWT = token;
                const newRequest = request.clone({ headers: request.headers.set('Authorization', `${token}`) });
                return next.handle(newRequest);
            }), 
            // Configuration du timeout http à 60 secondes par défaut
            timeout(DEFAULT_TIMEOUT));
        }
        return next.handle(request);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafTokenInterceptor, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafTokenInterceptor, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafTokenInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i0.Injector }] });

/**
 * @dynamic
 * Ce service permet d'enregistrer des statistiques SID
 */
class CnafStatsSidService {
    http;
    /**
     * URL API µS StatistiquesFront
     */
    cnafSidUrl = '/api/statistiquesfront/v1/sid';
    /**
     * Constructeur
     * @param document: Document
     * @param http: HttpClient
     */
    constructor(document, http) {
        this.http = http;
    }
    /**
     * Récupération du canal
     * Si dans le cookie, présence d'un paramètre appOs, le canal sera valorisé à 'mobile'
     */
    getCanal() {
        let canal;
        if (document.cookie.replace(/(?:(?:^|.*;\s*)appOs\s*\=\s*([^;]*).*$)|^.*$/, '$1') !== '') {
            canal = 'mobile';
        }
        return canal;
    }
    /**
     * Récupération du portail virtuel ( ex : caffr )
     * Recherche en priorité du cookie 'portailVirtuel' ; si non présent alors recherche dans l'url
     * @param url: string
     */
    getPortailVirtuel(url) {
        const portailVirtuelCookieName = 'portailVirtuel';
        const portailVirtuelCookieNameLengthMoreOne = portailVirtuelCookieName.length + 1;
        // Récupération du portail virtuel
        let portailVirtuel = document.cookie
            .split(';')
            .map((x) => x.trim())
            .filter((cookie) => {
            return cookie.substring(0, portailVirtuelCookieNameLengthMoreOne) === `${portailVirtuelCookieName}=`;
        })
            .map((cookie) => {
            return cookie.substring(portailVirtuelCookieNameLengthMoreOne);
        })[0] || undefined;
        if (!portailVirtuel) {
            const re = new RegExp('portal/([^/]+)');
            const matchPortail = re.exec(url);
            portailVirtuel = matchPortail !== null ? decodeURIComponent(matchPortail[1]) : '';
        }
        return portailVirtuel;
    }
    /**
     * Récupération des infos bornes ( paramètre d'url )
     * @param url: string
     */
    getInfosBornes(url) {
        const retour = {};
        const reUrl = new RegExp('(?:^[?|&]|[?|&])([^=]+)=([^&\n;]+)', 'g');
        let matches;
        while ((matches = reUrl.exec(url))) {
            // @ts-expect-error refacto
            retour[matches[1]] = matches[2];
        }
        return Object.keys(retour).length === 0 ? null : retour;
    }
    /**
     * Récupération des informations login (dans le cookie les paramètres commençant par & )
     * @param statsSid: string
     */
    getInfosLogin(statsSid) {
        const retour = {};
        let matches;
        if (statsSid.hit_site == null && statsSid.hit_ville == null && statsSid.hit_identifiant == null) {
            const reCookie = new RegExp('(?:^[=]|[&])([^=]+)=([^&\n;]+)', 'g');
            // @ts-expect-error refacto
            // eslint-disable-next-line no-cond-assign
            while ((matches = reCookie.exec(document.cookie))) {
                // @ts-expect-error refacto
                retour[matches[1]] = matches[2];
            }
        }
        return Object.keys(retour).length === 0 ? null : retour;
    }
    /**
     * Envoie l'objet en paramètre au µS StatistiquesFront
     * @param statsSidO: CnafStatsSidModel
     * @param functionCallBack: () => void Fonction après l'envoie des stats (facultatif)
     */
    postStats(statsSidO, functionCallBack) {
        if (statsSidO) {
            try {
                const url = document.location.href;
                const search = document.location.search;
                // Canal
                statsSidO.canal = this.getCanal();
                // Récupération du portail virtuel
                statsSidO.portailVirtuel = this.getPortailVirtuel(url);
                // Récupération des informations de bornes depuis l'url
                const infosBornes = this.getInfosBornes(search);
                if (infosBornes) {
                    for (const key of Object.keys(infosBornes)) {
                        // @ts-expect-error refacto
                        statsSidO[key] = infosBornes[key];
                    }
                }
                // Dans le cas du login, l'url n'est pas alimentée avec les paramètres, on va chercher dans le cookie
                const infosLogin = this.getInfosLogin(statsSidO);
                if (infosLogin) {
                    for (const key of Object.keys(infosLogin)) {
                        // @ts-expect-error refacto
                        statsSidO[key] = infosLogin[key];
                    }
                }
            }
            catch (error) {
                // Réinitialisation des valeurs
                statsSidO.portailVirtuel = '';
                statsSidO.hit_identifiant = '';
                statsSidO.borneId = '';
                statsSidO.hit_site = '';
                statsSidO.hit_ville = '';
            }
            Object.keys(statsSidO).forEach((key) => {
                switch (key) {
                    case 'composant':
                    case 'rubrique':
                    case 'sousRubrique':
                    case 'parametres':
                    case 'canal':
                    case 'portailVirtuel':
                    case 'borneId':
                        // on garde les propriétés
                        break;
                    case 'hit_site':
                    case 'hit_identifiant':
                    case 'hit_ville':
                        // remplacement de la clé au format camelCase
                        const keyCamelCase = key.replace(/([_][a-z])/g, (group) => group.toUpperCase().replace('_', ''));
                        // @ts-expect-error refacto
                        statsSidO[keyCamelCase] = statsSidO[key];
                        delete statsSidO[key];
                        break;
                    default:
                        // sinon on supprime la propriété car pas utile pour les stats
                        // @ts-expect-error refacto
                        delete statsSidO[key];
                }
            });
            // @ts-expect-error refacto
            if (!statsSidO['hitIdentifiant'] && statsSidO['borneId']) {
                // @ts-expect-error refacto
                statsSidO['hitIdentifiant'] = statsSidO['borneId'];
            }
            // @ts-expect-error refacto
            delete statsSidO['borneId'];
            this.httpPostStatsSid(statsSidO).subscribe({
                next: () => {
                    if (functionCallBack) {
                        functionCallBack();
                    }
                },
                error: (error) => {
                    console.error('Erreur post CnafStatsSid' + error);
                    if (functionCallBack) {
                        functionCallBack();
                    }
                }
            });
        }
        else {
            console.error("L'objet CnafStatsSidModel en paramètre est null");
        }
    }
    /**
     * Requête http post au µS StatistiquesFront
     * @param object: CnafStatsSidModel
     */
    httpPostStatsSid(object) {
        const headers = new HttpHeaders({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json;charset=UTF-8'
        });
        const options = { headers: headers };
        return this.http.post(this.cnafSidUrl, object, options);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafStatsSidService, deps: [{ token: DOCUMENT }, { token: i1$2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafStatsSidService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafStatsSidService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1$2.HttpClient }] });

/**
 * Directive de marquage Stat Sid
 **/
class NgCnafStatsSidDirective {
    statsSidService;
    /**
     * Constructeur
     * @param tagService: TagService
     */
    constructor(statsSidService) {
        this.statsSidService = statsSidService;
    }
    /**
     * Contenu du post
     */
    data;
    /**
     * si true le post des stats est envoyé - par défaut il est à true
     */
    doPost;
    /**
     * Fonction appellée une fois les stats envoyés | Facultatif
     */
    functionCallBack;
    /**
     * ngAfterViewInit
     */
    ngAfterViewInit() {
        if (this.doPost !== false) {
            if (this.functionCallBack) {
                this.statsSidService.postStats(this.data, this.functionCallBack);
            }
            else {
                this.statsSidService.postStats(this.data);
            }
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafStatsSidDirective, deps: [{ token: CnafStatsSidService }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafStatsSidDirective, selector: "ng-cnaf-stats-sid", inputs: { data: "data", doPost: "doPost", functionCallBack: "functionCallBack" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafStatsSidDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'ng-cnaf-stats-sid'
                }]
        }], ctorParameters: () => [{ type: CnafStatsSidService }], propDecorators: { data: [{
                type: Input
            }], doPost: [{
                type: Input
            }], functionCallBack: [{
                type: Input
            }] } });

/**
 * Modal d'incident technique pour la directive CnafTelechargementPDF
 */
/**
 * Component de NgCnafTelechargementPdfModalComponent
 */
class NgCnafTelechargementPdfModalComponent {
    bsModalRef;
    /**
     * Message d'incident technique
     */
    message;
    /**
     * Constructeur
     * @param bsModalRef: BsModalRef
     */
    constructor(bsModalRef) {
        this.bsModalRef = bsModalRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafTelechargementPdfModalComponent, deps: [{ token: i1$1.BsModalRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafTelechargementPdfModalComponent, selector: "ng-cnaf-telechargement-pdf-modal", ngImport: i0, template: `
    <div class="modal-header d-block">
      <button type="button" class="close-cnaf" aria-label="Fermer la popup" data-dismiss="modal" data-bs-dismiss="modal" aria-hidden="true" (click)="bsModalRef.hide()">
      </button>
      <div role="heading" aria-level="1" class="texte-medium text-primary"><span class="glyphicon glyphicon-alert text-danger" aria-hidden="true"></span> Téléchargement impossible</div>
    </div>
    <div class="modal-body">
      <div class="row ">
        <div class="col-sm-12">
          <p>{{ message }}</p>
          <!-- A réactiver pour la prise en charge mobile -->
          <!--<span class="hidden-xs">{{message}}</span><span class="visible-xs">{{messageMobile}}</span>-->
          <div class="float-end">
            <button type="button" class="btn btn-form-cnaf btn-majeur-cnaf" data-dismiss="modal" data-bs-dismiss="modal" (click)="bsModalRef.hide()">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafTelechargementPdfModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ng-cnaf-telechargement-pdf-modal',
                    template: `
    <div class="modal-header d-block">
      <button type="button" class="close-cnaf" aria-label="Fermer la popup" data-dismiss="modal" data-bs-dismiss="modal" aria-hidden="true" (click)="bsModalRef.hide()">
      </button>
      <div role="heading" aria-level="1" class="texte-medium text-primary"><span class="glyphicon glyphicon-alert text-danger" aria-hidden="true"></span> Téléchargement impossible</div>
    </div>
    <div class="modal-body">
      <div class="row ">
        <div class="col-sm-12">
          <p>{{ message }}</p>
          <!-- A réactiver pour la prise en charge mobile -->
          <!--<span class="hidden-xs">{{message}}</span><span class="visible-xs">{{messageMobile}}</span>-->
          <div class="float-end">
            <button type="button" class="btn btn-form-cnaf btn-majeur-cnaf" data-dismiss="modal" data-bs-dismiss="modal" (click)="bsModalRef.hide()">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  `
                }]
        }], ctorParameters: () => [{ type: i1$1.BsModalRef }] });

/**
 * Directive de téléchargement de PDF
 */
class NgCnafTelechargementPdfDirective {
    el;
    modalService;
    /**
     * Message d'incident technique à afficher dans la fenêtre modale
     */
    static MSG_MODAL_INCIDENT_TECHNIQUE = "Un incident technique s'est produit. Veuillez réessayer ultérieurement.";
    /**
     * Observable qui permet de télécharger le PDF
     */
    observablePDF;
    /**
     * Fonction appellée lors du succès de l'observable
     */
    onSuccess;
    /**
     * Fonction appellée lors l'échec de l'observable
     */
    onError;
    /**
     * Si à true, remplacement du content de l'élément ou est placé la directive
     * par 'Chargement en cours' pendant le téléchargement du PDF </br>
     * Si false, pas de remplacement ( exemple, utilisation de la directive sur une image)
     */
    noReplace;
    /**
     * Constructeur
     * @param el: ElementRef
     * @param modalService: BsModalService
     */
    constructor(el, modalService) {
        this.el = el;
        this.modalService = modalService;
    }
    /**
     * ngAfterViewInit - Modification du titre
     */
    ngAfterViewInit() {
        // Set du Titre
        let titre = this.el.nativeElement.title;
        if (titre) {
            titre = titre + " (nouvelle fenêtre - fichier PDF d'environ 250Ko)";
        }
        else {
            titre = "(nouvelle fenêtre - fichier PDF d'environ 250Ko)";
        }
        this.el.nativeElement.title = titre;
    }
    /**
     * Listenner du click
     */
    onClick() {
        // Remplacement du texte
        const textOriginal = this.replaceText(this.el, this.noReplace);
        const winObject = this.createWinObject(window);
        this.observablePDF.subscribe({
            // success
            next: (data) => {
                this.succesPDF(data, this.el, textOriginal, winObject);
            },
            // error
            error: (error) => {
                this.errorPDF(error, this.el, textOriginal, winObject);
            }
        });
    }
    /**
     * Remplace le textContent de l'élement en paramètre par 'Chargement en cours'
     * et désactive l'élément </br>
     * Si noReplace = true, pas de remplacement du textContent
     * @param el: ElementRef
     * @param noReplace: boolean
     */
    replaceText(el, noReplace) {
        let textOriginal = '';
        // Si textContent - pas de remplacement du texte
        if (noReplace === undefined || noReplace === false) {
            textOriginal = el.nativeElement.textContent;
            this.modifyText(el, 'Chargement en cours...');
        }
        el.nativeElement.disabled = true;
        return textOriginal;
    }
    /**
     * Modifie le textContent de l'élement
     * @param el: ElementRef
     * @param text: string
     */
    modifyText(el, text) {
        // Remplacement du texte que s'il y a une valeur
        if (text) {
            el.nativeElement.textContent = text;
        }
    }
    /**
     * Creation d'une fenêtre pour afficher le PDF
     * @param window: any
     */
    createWinObject(window) {
        let winObject;
        if (this.getCookieByICF('appOs')) {
            // Mobile - on ne fait rien
        }
        else {
            winObject = window.open('', '_blank');
            winObject.document.body.innerHTML = '<p id="chargement-pdf-cnaf">Chargement en cours...</p>';
        }
        return winObject;
    }
    /**
     * Affiche le PDF dans une nouvelle fenêtre
     * @param winObject: Window
     * @param file: Blob
     */
    showPDF(winObject, file) {
        if (this.getCookieByICF('appOs')) {
            this.showPdfMobile(window, file);
        }
        else {
            const fileURL = URL.createObjectURL(file);
            const a = document.createElement('a');
            a.appendChild(document.createTextNode("Cliquer ici si le document ne s'affiche pas"));
            a.id = 'lien-pdf-cnaf';
            a.href = fileURL;
            a.onclick = () => {
                setTimeout(() => {
                    if (!winObject || winObject.closed || typeof winObject.closed === undefined) {
                        // eslint-disable-next-line max-len
                        window.alert("Un module installé sur le navigateur (type 'Adblock' par exemple) empêche la visualisation du document.");
                    }
                }, 500);
            };
            if (/(android)/i.test(navigator.userAgent)) {
                a.download = new Date().getTime() + '-cnaf.pdf';
                a.onclick = () => {
                    setTimeout(() => {
                        if (winObject) {
                            winObject.close();
                        }
                    }, 500);
                };
            }
            if (winObject) {
                winObject.document.body.appendChild(a);
                winObject.document.getElementById('chargement-pdf-cnaf').setAttribute('style', 'display: none !important;');
                winObject.document.getElementById('lien-pdf-cnaf').click();
            }
        }
    }
    getCookieByICF(name) {
        return getCookie(name);
    }
    /**
     * Affiche le PDF dans une nouvelle fenêtre
     * @param window: Window
     * @param file: Blob
     */
    showPdfMobile(window, file) {
        if (this.getCookieByICF('appOs') === 'ios') {
            window.requestFileSystem(window.TEMPORARY, 5 * 1024 * 1024, (dir) => {
                const blobType = file.type.substring(file.type.indexOf('/') + 1);
                const filename = 'preview-cnaf.' + blobType;
                dir.root.getFile(filename, {
                    create: true
                }, (localFile) => {
                    localFile.createWriter((fileWriter) => {
                        this.createFichier(file).subscribe({
                            next: (data) => {
                                fileWriter.onwriteend = () => {
                                    // ouverture du fichier
                                    // eslint-disable-next-line no-undef
                                    const ref = cordova.InAppBrowser.open(localFile.toURL(), '_blank', 'location=no,closebuttoncaption=Fermer,EnableViewPortScale=yes,displaybtncnaf=yes');
                                    ref.addEventListener('exit', () => {
                                        // eslint-disable-next-line no-unused-vars
                                        localFile.remove(() => { }, (error) => { });
                                    });
                                };
                                // ecriture du contenu
                                fileWriter.write(data);
                            },
                            error: () => {
                                navigator.notification.alert("Impossible d'afficher le fichier.", () => { }, '', 'Fermer');
                            }
                        });
                    }, () => {
                        navigator.notification.alert("Impossible d'afficher le fichier.", () => { }, '', 'Fermer');
                    });
                });
            });
        }
        else {
            // android : download file
            // eslint-disable-next-line no-undef
            let path = cordova.file.externalCacheDirectory;
            if (path === null) {
                // eslint-disable-next-line no-undef
                path = cordova.file.cacheDirectory;
            }
            let directoryDownload = path;
            let subDirectoryDownload = '';
            if (this.getCookieByICF('appVersion').startsWith('2.0.') || this.getCookieByICF('appVersion').startsWith('2.1.')) {
                path = cordova.file.externalRootDirectory;
                if (path === null) {
                    path = cordova.file.dataDirectory;
                }
                directoryDownload = path + 'Download/';
                subDirectoryDownload = 'cnaf';
            }
            window.resolveLocalFileSystemURL(directoryDownload, (downloadDir) => {
                downloadDir.getDirectory(subDirectoryDownload, {
                    create: true
                }, (dir) => {
                    const filename = new Date().getTime() + '-cnaf.' + file.type.substring(file.type.indexOf('/') + 1);
                    dir.getFile(filename, {
                        create: true
                    }, (localFile) => {
                        localFile.createWriter((fileWriter) => {
                            this.createFichier(file).subscribe({
                                next: (data) => {
                                    fileWriter.onwriteend = () => {
                                        // ouverture du fichier in system pdf reader
                                        const cookieAppVersion = this.getCookieByICF('appVersion');
                                        // Pour pouvoir comparer les versions, on transforme celle-ci en nombre (exemple 2.2.0 devient 220)
                                        const cookieAppVersionInt = parseInt(cookieAppVersion.replace(/\./g, '-').split('-').join(''), 10);
                                        // eslint-disable-next-line no-undef
                                        if (cookieAppVersionInt === 200) {
                                            // eslint-disable-next-line no-undef
                                            cordova.InAppBrowser.open(localFile.toURL(), '_system');
                                        }
                                        else {
                                            let urlToOpen = localFile.toURL();
                                            // si la version est supérieure ou égale à 2.6.0 (260), il ne faut pas utiliser toURL mais nativeURL (cf. https://github.com/apache/cordova-plugin-file-transfer/issues/345#issuecomment-1381007463)
                                            if (cookieAppVersionInt >= 260) {
                                                urlToOpen = localFile.nativeURL;
                                            }
                                            // eslint-disable-next-line no-undef
                                            cordova.exec(() => { }, () => { }, 'CafPlugin', 'openFile', [urlToOpen]);
                                        }
                                    };
                                    // ecriture du contenu
                                    fileWriter.write(data);
                                },
                                error: () => {
                                    navigator.notification.alert("Impossible d'afficher le fichier.", () => { }, '', 'Fermer');
                                }
                            });
                        }, () => {
                            navigator.notification.alert("Impossible d'afficher le fichier.", () => { }, '', 'Fermer');
                        });
                    });
                });
            });
        }
    }
    /**
     * SuccessPDF
     * @param data: Blob
     * @param el: ElementRef
     * @param textOriginal: string
     * @param winObject: Window
     */
    succesPDF(data, el, textOriginal, winObject) {
        // Réactivation de l'élement
        el.nativeElement.disabled = false;
        this.modifyText(el, textOriginal);
        const file = new Blob([data], { type: 'application/pdf' });
        this.showPDF(winObject, file);
        // Appel de la fonction success passée en paramètre
        this.onSuccess(data);
    }
    /**
     * Error PDF
     * @param error: HttpErrorResponse
     * @param el: ElementRef
     * @param textOriginal: textOriginal
     * @param winObject: Window
     */
    errorPDF(error, el, textOriginal, winObject) {
        el.nativeElement.disabled = false;
        this.modifyText(el, textOriginal);
        if (winObject) {
            winObject.close();
        }
        let messageIncidentTechnique = NgCnafTelechargementPdfDirective.MSG_MODAL_INCIDENT_TECHNIQUE;
        if (error.headers) {
            if (error.headers.get('libelleerreurcaffr')) {
                // @ts-expect-error refacto
                messageIncidentTechnique = error.headers.get('libelleerreurcaffr');
            }
        }
        // Ouverture de la modal d'incident technique
        const initialState = {
            message: messageIncidentTechnique
        };
        this.modalService.show(NgCnafTelechargementPdfModalComponent, { initialState });
        // Appel de la fonction error passée en paramètre
        this.onError(error);
    }
    createFichier(file) {
        return new Observable((obs) => {
            const reader = this.getFileReader();
            reader.onerror = (err) => {
                obs.error(err);
            };
            reader.onabort = (err) => {
                obs.error(err);
            };
            reader.onload = () => {
                return obs.next(reader.result);
            };
            reader.onloadend = (e) => { };
            reader.readAsArrayBuffer(file);
        });
    }
    getFileReader() {
        const fileReader = new FileReader();
        const zoneOriginalInstance = fileReader.__zone_symbol__originalInstance;
        return zoneOriginalInstance || fileReader;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafTelechargementPdfDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.BsModalService }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafTelechargementPdfDirective, selector: "[ng-cnaf-telechargement-pdf]", inputs: { observablePDF: "observablePDF", onSuccess: "onSuccess", onError: "onError", noReplace: "noReplace" }, host: { listeners: { "click": "onClick()" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafTelechargementPdfDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[ng-cnaf-telechargement-pdf]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$1.BsModalService }], propDecorators: { observablePDF: [{
                type: Input
            }], onSuccess: [{
                type: Input
            }], onError: [{
                type: Input
            }], noReplace: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Ce service permet de récupérer les informations techniques de l'utilisateur ( mode allocataire )
 * qui sont fournis lors du paramétrage du CnafCommonsModule (voir [ici](#comment-utiliser-le-cnafcommonsmodule)).
 */
class CnafUserService {
    cnafTokenService;
    /**
     * Code organisme
     */
    #codeOrga;
    /**
     * Matricule
     */
    #matricule;
    /**
     * Date environnement caffr
     */
    #dateEnvCaffr;
    /**
     * Liste des groupes auxquelles le dossier appartient
     */
    #listGroups;
    /**
     * Liste des groupes possibles
     */
    #CNAF_LIST_GROUP;
    /**
     * roles de la personne ( récupéré à partir du token )
     */
    // tslint:disable-next-line:variable-name
    #roles;
    /**
     * idFoyer du compte ( récupéré à partir du token )
     */
    #idFoyer;
    /**
     * idPersonne du compte ( récupéré à partir du token )
     */
    #idPersonne;
    constructor(cnafAppConfigService, cnafTokenService) {
        this.cnafTokenService = cnafTokenService;
        const userConfig = cnafAppConfigService.getUserConfig();
        if (userConfig) {
            this.#codeOrga = userConfig.codeOrga;
            this.#matricule = userConfig.matricule;
            this.#dateEnvCaffr = userConfig.dateEnvCaffr;
            this.#listGroups = userConfig.listGroups;
            this.#CNAF_LIST_GROUP = userConfig.CNAF_LIST_GROUP;
        }
    }
    /**
     * Permet de savoir si le dossier fait parti du groupe passé en paramètre
     * @param groupId groupe
     * @returns <b>true:</b> appartient dans le groupe </br><b>false:</b> n'appartient pas au groupe
     */
    isInGroup(groupId) {
        if (this.#listGroups) {
            for (let i = 0, c = this.#listGroups.length; i < c; i++) {
                if (this.#listGroups[i] === groupId) {
                    return true;
                }
            }
        }
        return false;
    }
    get codeOrga() {
        return this.#codeOrga;
    }
    set codeOrga(code) {
        this.#codeOrga = code;
    }
    get matricule() {
        return this.#matricule;
    }
    set matricule(matricule) {
        this.#matricule = matricule;
    }
    get dateEnvCaffr() {
        return this.#dateEnvCaffr;
    }
    set dateEnvCaffr(dateAAAAMMJJ) {
        this.#dateEnvCaffr = dateAAAAMMJJ;
    }
    get listGroups() {
        return this.#listGroups;
    }
    set listGroups(listGroups) {
        this.#listGroups = listGroups;
    }
    set CNAF_LIST_GROUP(CNAF_LIST_GROUP) {
        this.#CNAF_LIST_GROUP = CNAF_LIST_GROUP;
    }
    get CNAF_LIST_GROUP() {
        return this.#CNAF_LIST_GROUP;
    }
    get idFoyer() {
        if (!this.#idFoyer) {
            this.#idFoyer = this.cnafTokenService.getTokenPropertie('idFoyer');
        }
        return this.#idFoyer;
    }
    get idPersonne() {
        if (!this.#idPersonne) {
            this.#idPersonne = this.cnafTokenService.getTokenPropertie('idPersonne');
        }
        return this.#idPersonne;
    }
    get roles() {
        if (!this.#roles) {
            this.#roles = this.cnafTokenService.getTokenPropertie('roles');
        }
        return this.#roles;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafUserService, deps: [{ token: CnafAppConfigService }, { token: CnafTokenService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafUserService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CnafAppConfigService }, { type: CnafTokenService }] });

/**
 * Configuration du routeur par défaut
 * - Appel du PageReady du thème
 * - Scroll réinitialisé à chaque changement de page ( sauf si passage de paramètre scroll à false)
 */
class CnafRouterConfigService {
    router;
    cnafUserService;
    /**
     * Constructeur
     * @param router Module Router
     */
    constructor(router, cnafUserService) {
        this.router = router;
        this.cnafUserService = cnafUserService;
    }
    /**
     * Chargement configuration du router
     */
    async getConfigs() {
        if (this.router) {
            const router = this.router;
            const cnafUserService = this.cnafUserService;
            return lastValueFrom(new Observable(function (observer) {
                // Appel fonction JS du thème au NavigationEnd
                router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
                    // Appel pageReady
                    setTimeout(() => {
                        pageReady();
                    }, 100);
                    // Appel clearTimeoutExpireSession pour application mobile quand on est authentifié
                    if (typeof clearTimeoutExpireSession === 'function' &&
                        cnafUserService.CNAF_LIST_GROUP &&
                        (cnafUserService.isInGroup(cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES) ||
                            cnafUserService.isInGroup(cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_EXPERIMENTATION))) {
                        clearTimeoutExpireSession();
                        setExpirationSessionTimeout(getTempsInactiviteMax());
                    }
                });
                // Init scroolTo
                router.events
                    .pipe(filter((event) => event instanceof ActivationEnd))
                    // @ts-ignore
                    .subscribe((event) => {
                    if (event.snapshot.data.scroll !== false) {
                        window.scrollTo(0, 0);
                    }
                });
                observer.next(true);
                observer.complete();
            }));
        }
        return of(true);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafRouterConfigService, deps: [{ token: i1$3.Router, optional: true }, { token: CnafUserService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafRouterConfigService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafRouterConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$3.Router, decorators: [{
                    type: Optional
                }] }, { type: CnafUserService }] });

/**
 * Directive qui permet d'associer la toucher Espace à l'action click
 * pour respecter l'accessibilité ( navigation avec le clavier )
 */
class NgCnafHandlerKeyAccessibility {
    element;
    /**
     * Constructeur
     * @param element: ElementRef<HTMLElement>
     */
    constructor(element) {
        this.element = element;
    }
    /**
     * HostListener qui simule un click lors de l'appuie sur la touche Espace
     * @param event KeyboardEvent
     */
    onKeyUpHandler(event) {
        // Filtre touche espace
        if (event.key === ' ' || event.key === 'Escape') {
            this.element.nativeElement.click();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafHandlerKeyAccessibility, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafHandlerKeyAccessibility, selector: "[ngCnafHandlerKeyAccessibility]", host: { listeners: { "keyup": "onKeyUpHandler($event)" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafHandlerKeyAccessibility, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[ngCnafHandlerKeyAccessibility]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { onKeyUpHandler: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

var StepCnafBarreProgressionEnum;
(function (StepCnafBarreProgressionEnum) {
    StepCnafBarreProgressionEnum["TroisPoints"] = "...";
    StepCnafBarreProgressionEnum["Pastille"] = "pastille";
})(StepCnafBarreProgressionEnum || (StepCnafBarreProgressionEnum = {}));

/**
 * Composant barre de progression
 * [Documentation - showcase](http://docweb.intra.cnaf/edenangular/components/#component-barre-progression)
 */
class NgCnafBarreProgressionComponent {
    /**
     * Breakpoint largeur minimum : défault 640
     * @private
     */
    static BREAKPOINT_WIDTH_MIN = 640;
    /**
     * Breakpoint maximum : défault 1024
     * @private
     */
    static BREAKPOINT_WIDTH_MAX = 1024;
    /**
     * Variable pour la valeur supérieur de la pastille ( affiché lorsqu'une mobile )
     */
    numberPastilleTop;
    /**
     * Variable pour la valeur inférieure de la pastille ( affiché lorsqu'une mobile )
     */
    numberPastilleBottom;
    /**
     * Objet servant à afficher les étapes dans le template html
     */
    stepsView;
    /**
     * Liste des étapes
     */
    steps;
    /**
     * Nombre d'item maximum affiché en mode PC : défaut 6
     */
    maxItem = 6;
    /**
     * Nombre d'item maximum affiché en mode tablette : défaut 4
     */
    maxItemTablette = 4;
    /**
     * ngOnInit
     */
    ngOnInit() {
        const screenWidth = this.getWindowOuterWidth();
        let maxItemView = this.maxItem;
        // Copie du tableau en passant par un JSON, car sinon une copie simple sur le tableau garde le lien sur les objets
        this.stepsView = JSON.parse(JSON.stringify(this.steps));
        let indexActiveElement = this.steps.findIndex((e) => e.active) + 1;
        if (!indexActiveElement)
            indexActiveElement = this.steps.length - 1;
        if (screenWidth >= NgCnafBarreProgressionComponent.BREAKPOINT_WIDTH_MIN) {
            if (screenWidth < NgCnafBarreProgressionComponent.BREAKPOINT_WIDTH_MAX)
                maxItemView = this.maxItemTablette;
            // Nombre d'étape trop important => masquage d'étape
            if (this.steps.length > maxItemView) {
                const indexSeparator = this.steps.findIndex((e) => e.separateur) + 1;
                const deltaActiveSeparator = indexActiveElement - indexSeparator;
                const maxItemAfterSeparator = maxItemView - indexSeparator;
                if (deltaActiveSeparator - maxItemAfterSeparator <= 0) {
                    const debut = indexSeparator + maxItemAfterSeparator;
                    this.stepsView.slice(debut).map((e) => (e.hidden = true));
                    this.stepsView.push({ technicalStep: StepCnafBarreProgressionEnum.TroisPoints, nom: '', hidden: false });
                }
                else {
                    if (deltaActiveSeparator + maxItemAfterSeparator > this.steps.length - indexSeparator) {
                        // Etape active entre le début et le séparateur => masquage des étapes entre le séparateur et la fin
                        // ( en faisant la différence des étapes que l'on peut encore afficher
                        const debut = indexSeparator;
                        const fin = this.steps.length - maxItemAfterSeparator;
                        this.stepsView.slice(debut, fin).map((e) => (e.hidden = true));
                        this.stepsView.splice(fin, 0, { technicalStep: StepCnafBarreProgressionEnum.TroisPoints, nom: '', hidden: false });
                    }
                    else {
                        // Cas ou on doit masquer des étapes avant et après l'étape active
                        const debut = indexSeparator;
                        const finIntermediaire = deltaActiveSeparator - Math.floor(maxItemAfterSeparator / 2) + indexSeparator;
                        const debutIntermediaire = deltaActiveSeparator + Math.round(maxItemAfterSeparator / 2) + indexSeparator;
                        const fin = this.steps.length;
                        this.stepsView.slice(debut, finIntermediaire).map((e) => (e.hidden = true));
                        this.stepsView.slice(debutIntermediaire, fin).map((e) => (e.hidden = true));
                        this.stepsView.splice(finIntermediaire, 0, { technicalStep: StepCnafBarreProgressionEnum.TroisPoints, nom: '', hidden: false });
                        this.stepsView.splice(debutIntermediaire + 1, 0, {
                            technicalStep: StepCnafBarreProgressionEnum.TroisPoints,
                            nom: '',
                            hidden: false
                        });
                    }
                }
            }
        }
        else {
            // Cas mobile - affichage d'une seule étape avec une pastille
            this.stepsView.slice(0, indexActiveElement - 1).map((e) => (e.hidden = true));
            this.stepsView.slice(indexActiveElement).map((e) => (e.hidden = true));
            this.stepsView.splice(this.stepsView.length, 0, { technicalStep: StepCnafBarreProgressionEnum.Pastille, nom: '', hidden: false });
            this.numberPastilleTop = indexActiveElement;
            this.numberPastilleBottom = this.steps.length;
        }
    }
    /**
     *
     */
    onResize() {
        this.ngOnInit();
    }
    /**
     *
     */
    getWindowOuterWidth() {
        return window.outerWidth;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafBarreProgressionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: NgCnafBarreProgressionComponent, selector: "ng-cnaf-barre-progression", inputs: { steps: "steps", maxItem: "maxItem", maxItemTablette: "maxItemTablette" }, host: { listeners: { "window:resize": "onResize()" } }, ngImport: i0, template: "<ol class=\"barre-progression-cnaf\">\n  @for (step of stepsView; track step; let i = $index) {\n    <li [ngClass]=\"{ active: step.active, inactive: !step.active, separator: step.separateur }\" [hidden]=\"step.hidden\"\n      >{{ step.nom }}<span class=\"item-etat-cnaf\"></span>\n      @if (step.active) {\n        <span class=\"sr-only\">Phase en cours</span>\n      }\n      @if (step.technicalStep === \"...\") {\n        <span class=\"more-item-cnaf\" style=\"position: absolute; font-weight: bold; color: #000000; right: 3px\">...</span>\n      }\n      @if (step.technicalStep === \"pastille\") {\n        <span\n          style=\"position: absolute; font-size: 0.75rem; font-weight: normal; line-height: 10px; top: 5px; right: 4px\"\n          class=\"current-item-cnaf badge\"\n          >{{ numberPastilleTop }}<hr style=\"margin: 4px 0\" />{{ numberPastilleBottom }}</span\n        >\n      }\n    </li>\n  }\n</ol>\n", styles: ["ol.barre-progression-cnaf>li,ul.barre-progression-cnaf>li{padding-right:25px}li[hidden]{display:none}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafBarreProgressionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ng-cnaf-barre-progression', template: "<ol class=\"barre-progression-cnaf\">\n  @for (step of stepsView; track step; let i = $index) {\n    <li [ngClass]=\"{ active: step.active, inactive: !step.active, separator: step.separateur }\" [hidden]=\"step.hidden\"\n      >{{ step.nom }}<span class=\"item-etat-cnaf\"></span>\n      @if (step.active) {\n        <span class=\"sr-only\">Phase en cours</span>\n      }\n      @if (step.technicalStep === \"...\") {\n        <span class=\"more-item-cnaf\" style=\"position: absolute; font-weight: bold; color: #000000; right: 3px\">...</span>\n      }\n      @if (step.technicalStep === \"pastille\") {\n        <span\n          style=\"position: absolute; font-size: 0.75rem; font-weight: normal; line-height: 10px; top: 5px; right: 4px\"\n          class=\"current-item-cnaf badge\"\n          >{{ numberPastilleTop }}<hr style=\"margin: 4px 0\" />{{ numberPastilleBottom }}</span\n        >\n      }\n    </li>\n  }\n</ol>\n", styles: ["ol.barre-progression-cnaf>li,ul.barre-progression-cnaf>li{padding-right:25px}li[hidden]{display:none}\n"] }]
        }], propDecorators: { steps: [{
                type: Input
            }], maxItem: [{
                type: Input
            }], maxItemTablette: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

/**
 * Directive issue de https://github.com/ng-bootstrap/ng-bootstrap
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class NgCnafButtonLabel {
    /**
     * active
     */
    active;
    /**
     * disabled
     */
    disabled;
    /**
     * focused
     */
    focused;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafButtonLabel, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafButtonLabel, selector: "[ngCnafButtonLabel]", host: { properties: { "class.btn": "true", "class.active": "active", "class.disabled": "disabled", "class.focus": "focused" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafButtonLabel, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngCnafButtonLabel]',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: { '[class.btn]': 'true', '[class.active]': 'active', '[class.disabled]': 'disabled', '[class.focus]': 'focused' }
                }]
        }] });

const NGB_CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgCnafCheckbox2Component),
    multi: true
};
/**
 * Directive issue de https://github.com/ng-bootstrap/ng-bootstrap
 * Elle sert à remplacer l'utilisation des checkbox de ngx-bootstrap
 *
 * Allows to easily create Bootstrap-style checkbox buttons.
 *
 * Integrates with forms, so the value of a checked button is bound to the underlying form control
 * either in a reactive or template-driven way.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class NgCnafCheckbox2Component {
    label;
    cd;
    // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
    static ngAcceptInputType_disabled;
    checked;
    /**
     * If `true`, the checkbox button will be disabled
     */
    disabled = false;
    /**
     * The form control value when the checkbox is checked.
     */
    valueChecked = true;
    /**
     * The form control value when the checkbox is unchecked.
     */
    valueUnChecked = false;
    onChange = (value) => {
        value;
    };
    onTouched = () => { };
    set focused(isFocused) {
        this.label.focused = isFocused;
        if (!isFocused) {
            this.onTouched();
        }
    }
    constructor(label, cd) {
        this.label = label;
        this.cd = cd;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onInputChange($event) {
        const modelToPropagate = $event.target.checked ? this.valueChecked : this.valueUnChecked;
        this.onChange(modelToPropagate);
        this.onTouched();
        this.writeValue(modelToPropagate);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.label.disabled = isDisabled;
    }
    writeValue(value) {
        this.checked = value === this.valueChecked;
        this.label.active = this.checked;
        // label won't be updated, if it is inside the OnPush component when [ngModel] changes
        this.cd.markForCheck();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafCheckbox2Component, deps: [{ token: NgCnafButtonLabel }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafCheckbox2Component, selector: "[ngCnafButton][type=checkbox]", inputs: { disabled: "disabled", valueChecked: "valueChecked", valueUnChecked: "valueUnChecked" }, host: { listeners: { "change": "onInputChange($event)", "focus": "focused = true", "blur": "focused = false" }, properties: { "checked": "checked", "disabled": "disabled" } }, providers: [NGB_CHECKBOX_VALUE_ACCESSOR], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafCheckbox2Component, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[ngCnafButton][type=checkbox]',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        '[checked]': 'checked',
                        '[disabled]': 'disabled',
                        '(change)': 'onInputChange($event)',
                        '(focus)': 'focused = true',
                        '(blur)': 'focused = false'
                    },
                    providers: [NGB_CHECKBOX_VALUE_ACCESSOR]
                }]
        }], ctorParameters: () => [{ type: NgCnafButtonLabel }, { type: i0.ChangeDetectorRef }], propDecorators: { disabled: [{
                type: Input
            }], valueChecked: [{
                type: Input
            }], valueUnChecked: [{
                type: Input
            }] } });

class ClickOutsideDirective {
    elementRef;
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    clickOutside = new EventEmitter();
    onClick(event, targetElement) {
        if (!targetElement) {
            return;
        }
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(event);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ClickOutsideDirective, selector: "[clickOutside]", outputs: { clickOutside: "clickOutside" }, host: { listeners: { "document:click": "onClick($event,$event.target)" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[clickOutside]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { clickOutside: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event', '$event.target']]
            }] } });

class FocusOutsideDirective {
    elementRef;
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    focusOutside = new EventEmitter();
    onKeyup(event) {
        const focusInside = this.elementRef.nativeElement.contains(document.activeElement);
        if (!focusInside) {
            this.focusOutside.emit(event);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FocusOutsideDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FocusOutsideDirective, selector: "[focusOutside]", outputs: { focusOutside: "focusOutside" }, host: { listeners: { "document:keyup": "onKeyup($event)" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FocusOutsideDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[focusOutside]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { focusOutside: [{
                type: Output
            }], onKeyup: [{
                type: HostListener,
                args: ['document:keyup', ['$event']]
            }] } });

class ListFilterPipe {
    transform(items, filter) {
        if (!items || !filter) {
            return items;
        }
        return items.filter((item) => this.applyFilter(item, filter));
    }
    applyFilter(item, filter) {
        if (typeof item.text === 'string' && typeof filter.text === 'string') {
            return !(filter.text && item.text && item.text.toLowerCase().indexOf(filter.text.toLowerCase()) === -1);
        }
        else {
            return !(filter.text && item.text && item.text.toString().toLowerCase().indexOf(filter.text.toString().toLowerCase()) === -1);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ListFilterPipe, name: "multiSelectFilter", pure: false });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'multiSelectFilter',
                    pure: false
                }]
        }] });

class ListItem {
    id = '';
    text = '';
    constructor(source) {
        if (typeof source === 'string' || typeof source === 'number') {
            this.id = this.text = source;
        }
        if (typeof source === 'object') {
            this.id = source.id;
            this.text = source.text;
        }
    }
}

const DROPDOWN_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgCnafMultiselectComponent),
    multi: true
};
const noop = () => { };
class NgCnafMultiselectComponent {
    listFilterPipe;
    cdr;
    cnafAppConfigService;
    _data = [];
    selectedItems = [];
    isDropdownOpen = true;
    _label = 'Sélection';
    _sourceDataType = null; // to keep note of the source data type. could be array of string/number/object
    _sourceDataFields = []; // store source data fields names
    filter = new ListItem(this.data);
    defaultSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'text',
        disabledField: 'isDisabled',
        enableCheckAll: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: false,
        limitSelection: -1,
        clearSearchFilter: true,
        maxHeight: 197,
        itemsShowLimit: 999999999999,
        searchPlaceholderText: 'Search',
        noDataAvailablePlaceholderText: 'Pas de données disponibles',
        noFilteredDataAvailablePlaceholderText: 'No filtered data available',
        closeDropDownOnSelection: false,
        showSelectedItemsAtTop: false,
        defaultOpen: false,
        allowRemoteDataSearch: false
    };
    _settings = this.defaultSettings;
    imgSrc = '';
    imgSrcOpen = '';
    imgSrcClose = '/icfstatiquesangularappli/dist/images/FlecheBas-gris.png';
    imgSrcSelect = '/icfstatiquesangularappli/dist/images/pic-coche-vert-reduit.png';
    set label(value) {
        if (value) {
            this._label = value;
        }
        else {
            this._label = 'Select';
        }
    }
    disabled = false;
    set settings(value) {
        if (value) {
            this._settings = Object.assign(this.defaultSettings, value);
        }
        else {
            this._settings = Object.assign(this.defaultSettings);
        }
    }
    set data(value) {
        if (!value) {
            this._data = [];
        }
        else {
            const firstItem = value[0];
            this._sourceDataType = typeof firstItem;
            this._sourceDataFields = this.getFields(firstItem);
            this._data = value.map((item) => typeof item === 'string' || typeof item === 'number'
                ? new ListItem(item)
                : new ListItem({
                    id: item[this._settings.idField !== undefined ? this._settings.idField : ''],
                    text: item[this._settings.textField !== undefined ? this._settings.textField : '']
                    //isDisabled: item[this._settings.disabledField]
                }));
        }
    }
    onDropDownClose = new EventEmitter();
    onSelect = new EventEmitter();
    onDeSelect = new EventEmitter();
    onTouchedCallback = noop;
    onChangeCallback = noop;
    constructor(listFilterPipe, cdr, cnafAppConfigService) {
        this.listFilterPipe = listFilterPipe;
        this.cdr = cdr;
        this.cnafAppConfigService = cnafAppConfigService;
        this.imgSrc = this.imgSrcClose;
        this.imgSrcOpen = '/icfstatiquesangularappli/dist/images/' + this.cnafAppConfigService.getEspace() + '/FlecheHaut.png';
    }
    onItemClick($event, item) {
        // if (this.disabled || item.isDisabled) {
        //   return false;
        // }
        const found = this.isSelected(item);
        const allowAdd = this._settings.limitSelection === -1 ||
            (this._settings.limitSelection > 0 && this.selectedItems.length < this._settings.limitSelection);
        if (!found) {
            if (allowAdd) {
                this.addSelected(item);
            }
        }
        else {
            this.removeSelected(item);
        }
        const li = $event.currentTarget;
        li.firstElementChild.focus();
        if (this._settings.singleSelection && this._settings.closeDropDownOnSelection) {
            this.closeDropdown();
        }
    }
    writeValue(value) {
        if (value !== undefined && value !== null && value.length > 0) {
            if (this._settings.singleSelection) {
                try {
                    if (value.length >= 1) {
                        const firstItem = value[0];
                        this.selectedItems = [
                            typeof firstItem === 'string' || typeof firstItem === 'number'
                                ? new ListItem(firstItem)
                                : new ListItem({
                                    id: firstItem[this._settings.idField !== undefined ? this._settings.idField : ''],
                                    text: firstItem[this._settings.textField !== undefined ? this._settings.textField : '']
                                    //isDisabled: firstItem[this._settings.disabledField]
                                })
                        ];
                    }
                }
                catch (e) {
                    // console.error(e.body.msg);
                }
            }
            else {
                const _data = value.map((item) => typeof item === 'string' || typeof item === 'number'
                    ? new ListItem(item)
                    : new ListItem({
                        id: item[this._settings.idField != undefined ? this._settings.idField : ''],
                        text: item[this._settings.textField != undefined ? this._settings.textField : '']
                        //isDisabled: item[this._settings.disabledField]
                    }));
                if (this._settings.limitSelection != undefined && this._settings.limitSelection > 0) {
                    this.selectedItems = _data.splice(0, this._settings.limitSelection);
                }
                else {
                    this.selectedItems = _data;
                }
            }
        }
        else {
            this.selectedItems = [];
        }
        this.onChangeCallback(value);
        this.cdr.markForCheck();
    }
    // From ControlValueAccessor interface
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    // From ControlValueAccessor interface
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    // Set touched on blur
    onTouched() {
        //this.closeDropdown();
        this.onTouchedCallback();
    }
    trackByFn(index, item) {
        return item.id;
    }
    isSelected(clickedItem) {
        let found = false;
        this.selectedItems.forEach((item) => {
            if (clickedItem.id === item.id) {
                found = true;
            }
        });
        return found;
    }
    isLimitSelectionReached() {
        return this._settings.limitSelection === this.selectedItems.length;
    }
    itemShowRemaining() {
        const result = this._settings.itemsShowLimit !== undefined ? this._settings.itemsShowLimit : 0;
        return this.selectedItems.length - result;
    }
    addSelected(item) {
        if (this._settings.singleSelection) {
            this.selectedItems = [];
            this.selectedItems.push(item);
        }
        else {
            this.selectedItems.push(item);
        }
        this.onChangeCallback(this.emittedValue(this.selectedItems));
        this.onSelect.emit(this.emittedValue(item));
    }
    removeSelected(itemSel) {
        this.selectedItems.forEach((item) => {
            if (itemSel.id === item.id) {
                this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
            }
        });
        this.onChangeCallback(this.emittedValue(this.selectedItems));
        this.onDeSelect.emit(this.emittedValue(itemSel));
    }
    emittedValue(val) {
        const selected = [];
        if (Array.isArray(val)) {
            val.map((item) => {
                selected.push(this.objectify(item));
            });
        }
        else {
            if (val) {
                return this.objectify(val);
            }
        }
        return selected;
    }
    objectify(val) {
        if (this._sourceDataType === 'object') {
            const obj = {};
            const id = this._settings.idField !== undefined ? this._settings.idField : '';
            const text = this._settings.textField !== undefined ? this._settings.textField : '';
            obj[id] = val.id;
            obj[text] = val.text;
            return obj;
        }
        if (this._sourceDataType === 'number') {
            return Number(val.id);
        }
        else {
            return val.text;
        }
    }
    toggleDropdown(evt) {
        evt.preventDefault();
        if (this.disabled && this._settings.singleSelection) {
            return;
        }
        this._settings.defaultOpen = !this._settings.defaultOpen;
        if (this._settings.defaultOpen) {
            this.imgSrc = this.imgSrcOpen;
        }
        if (!this._settings.defaultOpen) {
            if (this.selectedItems.length > 0) {
                this.imgSrc = this.imgSrcSelect;
            }
            else {
                this.imgSrc = this.imgSrcClose;
            }
            this.onDropDownClose.emit();
        }
    }
    closeDropdown() {
        this._settings.defaultOpen = false;
        // clear search text
        if (this._settings.clearSearchFilter) {
            this.filter.text = '';
        }
        if (this.selectedItems.length > 0) {
            this.imgSrc = this.imgSrcSelect;
        }
        else {
            this.imgSrc = this.imgSrcClose;
        }
        this.onDropDownClose.emit();
    }
    getFields(inputData) {
        const fields = [];
        if (typeof inputData !== 'object') {
            return fields;
        }
        // eslint-disable-next-line guard-for-in
        for (const prop in inputData) {
            fields.push(prop);
        }
        return fields;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafMultiselectComponent, deps: [{ token: ListFilterPipe }, { token: i0.ChangeDetectorRef }, { token: CnafAppConfigService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: NgCnafMultiselectComponent, selector: "ng-cnaf-multiselect", inputs: { label: "label", disabled: "disabled", settings: "settings", data: "data" }, outputs: { onDropDownClose: "onDropDownClose", onSelect: "onSelect", onDeSelect: "onDeSelect" }, host: { listeners: { "blur": "onTouched()" } }, providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR], ngImport: i0, template: "<div (blur)=\"onTouched()\" class=\"multiselect-conteneur\" (clickOutside)=\"closeDropdown()\" (focusOutside)=\"closeDropdown()\">\n  <button\n    [attr.aria-expanded]=\"_settings.defaultOpen\"\n    aria-controls=\"myListToControl\"\n    type=\"button\"\n    class=\"btn btn-default dropdown-toggle btn-block texte2-cnaf\"\n    (click)=\"toggleDropdown($event)\"\n    data-ng-disabled=\"disabled\"\n  >\n    <span class=\"multiselect2\"\n      >{{ _label }}\n      <img [src]=\"imgSrc\" alt=\"\" class=\"float-end pull-right multiselect\" />\n    </span>\n  </button>\n  <div class=\"dropdown-list\" [hidden]=\"!_settings.defaultOpen\">\n    <ul class=\"item2 col-sm-12 col-xs-12\" [style.maxHeight]=\"_settings.maxHeight + 'px'\">\n      @for (item of _data | multiSelectFilter: filter; track item; let i = $index) {\n        <li (click)=\"onItemClick($event, item)\" class=\"multiselect-item-checkbox texte-info-cnaf\">\n          <input type=\"checkbox\" [attr.aria-label]=\"item.text\" [checked]=\"isSelected(item)\" class=\"\" />\n          <span>{{ item.text }}</span>\n        </li>\n      }\n      @if (_data.length === 0 && !_settings.allowRemoteDataSearch) {\n        <li class=\"no-data\">\n          <h5>{{ _settings.noDataAvailablePlaceholderText }}</h5>\n        </li>\n      }\n    </ul>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: ClickOutsideDirective, selector: "[clickOutside]", outputs: ["clickOutside"] }, { kind: "directive", type: FocusOutsideDirective, selector: "[focusOutside]", outputs: ["focusOutside"] }, { kind: "pipe", type: ListFilterPipe, name: "multiSelectFilter" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafMultiselectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ng-cnaf-multiselect', providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div (blur)=\"onTouched()\" class=\"multiselect-conteneur\" (clickOutside)=\"closeDropdown()\" (focusOutside)=\"closeDropdown()\">\n  <button\n    [attr.aria-expanded]=\"_settings.defaultOpen\"\n    aria-controls=\"myListToControl\"\n    type=\"button\"\n    class=\"btn btn-default dropdown-toggle btn-block texte2-cnaf\"\n    (click)=\"toggleDropdown($event)\"\n    data-ng-disabled=\"disabled\"\n  >\n    <span class=\"multiselect2\"\n      >{{ _label }}\n      <img [src]=\"imgSrc\" alt=\"\" class=\"float-end pull-right multiselect\" />\n    </span>\n  </button>\n  <div class=\"dropdown-list\" [hidden]=\"!_settings.defaultOpen\">\n    <ul class=\"item2 col-sm-12 col-xs-12\" [style.maxHeight]=\"_settings.maxHeight + 'px'\">\n      @for (item of _data | multiSelectFilter: filter; track item; let i = $index) {\n        <li (click)=\"onItemClick($event, item)\" class=\"multiselect-item-checkbox texte-info-cnaf\">\n          <input type=\"checkbox\" [attr.aria-label]=\"item.text\" [checked]=\"isSelected(item)\" class=\"\" />\n          <span>{{ item.text }}</span>\n        </li>\n      }\n      @if (_data.length === 0 && !_settings.allowRemoteDataSearch) {\n        <li class=\"no-data\">\n          <h5>{{ _settings.noDataAvailablePlaceholderText }}</h5>\n        </li>\n      }\n    </ul>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: ListFilterPipe }, { type: i0.ChangeDetectorRef }, { type: CnafAppConfigService }], propDecorators: { label: [{
                type: Input
            }], disabled: [{
                type: Input
            }], settings: [{
                type: Input
            }], data: [{
                type: Input
            }], onDropDownClose: [{
                type: Output
            }], onSelect: [{
                type: Output
            }], onDeSelect: [{
                type: Output
            }], onTouched: [{
                type: HostListener,
                args: ['blur']
            }] } });

let nextId = 0;
const NGB_RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgCnafRadioGroup),
    multi: true
};
/**
 * Directive issue de https://github.com/ng-bootstrap/ng-bootstrap
 */
// eslint-disable-next-line @angular-eslint/no-host-metadata-property
/**
 * Allows to easily create Bootstrap-style radio buttons.
 *
 * Integrates with forms, so the value of a checked button is bound to the underlying form control
 * either in a reactive or template-driven way.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class NgCnafRadioGroup {
    #radios = new Set();
    #value = null;
    #disabled;
    get disabled() {
        return this.#disabled;
    }
    set disabled(isDisabled) {
        this.setDisabledState(isDisabled);
    }
    /**
     * Name of the radio group applied to radio input elements.
     *
     * Will be applied to all radio input elements inside the group,
     * unless [`NgbRadio`](#/components/buttons/api#NgbRadio)'s specify names themselves.
     *
     * If not provided, will be generated in the `ngb-radio-xx` format.
     */
    name = `ng-cnaf-radio-${nextId++}`;
    onChange = (_) => { };
    onTouched = () => { };
    onRadioChange(radio) {
        this.writeValue(radio.value);
        this.onChange(radio.value);
    }
    onRadioValueUpdate() {
        this.#updateRadiosValue();
    }
    register(radio) {
        this.#radios.add(radio);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.#disabled = isDisabled;
        this.#updateRadiosDisabled();
    }
    unregister(radio) {
        this.#radios.delete(radio);
    }
    writeValue(value) {
        this.#value = value;
        this.#updateRadiosValue();
    }
    #updateRadiosValue() {
        this.#radios.forEach((radio) => radio.updateValue(this.#value));
    }
    #updateRadiosDisabled() {
        this.#radios.forEach((radio) => radio.updateDisabled());
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafRadioGroup, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafRadioGroup, selector: "[ngCnafRadioGroup]", inputs: { name: "name" }, host: { attributes: { "role": "radiogroup" } }, providers: [NGB_RADIO_VALUE_ACCESSOR], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafRadioGroup, decorators: [{
            type: Directive,
            args: [{ selector: '[ngCnafRadioGroup]', host: { role: 'radiogroup' }, providers: [NGB_RADIO_VALUE_ACCESSOR] }]
        }], propDecorators: { name: [{
                type: Input
            }] } });

/**
 * Directive issue de https://github.com/ng-bootstrap/ng-bootstrap
 *
 * A directive that marks an input of type "radio" as a part of the
 * [`NgbRadioGroup`](#/components/buttons/api#NgbRadioGroup).
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class NgCnafRadio {
    group;
    label;
    renderer;
    element;
    cd;
    #checked;
    #disabled;
    #value = null;
    /**
     * The value for the 'name' property of the input element.
     *
     * All inputs of the radio group should have the same name. If not specified,
     * the name of the enclosing group is used.
     */
    name;
    /**
     * The form control value when current radio button is checked.
     */
    set value(value) {
        this.#value = value;
        const stringValue = value ? value.toString() : '';
        this.renderer.setProperty(this.element.nativeElement, 'value', stringValue);
        this.group.onRadioValueUpdate();
    }
    /**
     * If `true`, current radio button will be disabled.
     */
    set disabled(isDisabled) {
        this.#disabled = isDisabled !== false;
        this.updateDisabled();
    }
    set focused(isFocused) {
        if (this.label) {
            this.label.focused = isFocused;
        }
        if (!isFocused) {
            this.group.onTouched();
        }
    }
    get checked() {
        return this.#checked;
    }
    get disabled() {
        return this.group.disabled || this.#disabled;
    }
    get value() {
        return this.#value;
    }
    get nameAttr() {
        return this.name || this.group.name;
    }
    constructor(group, label, renderer, element, cd) {
        this.group = group;
        this.label = label;
        this.renderer = renderer;
        this.element = element;
        this.cd = cd;
        this.group.register(this);
        this.updateDisabled();
    }
    ngOnDestroy() {
        this.group.unregister(this);
    }
    onChange() {
        this.group.onRadioChange(this);
    }
    updateValue(value) {
        // label won't be updated, if it is inside the OnPush component when [ngModel] changes
        if (this.value !== value) {
            this.cd.markForCheck();
        }
        this.#checked = this.value === value;
        this.label.active = this.#checked;
    }
    updateDisabled() {
        this.label.disabled = this.disabled;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafRadio, deps: [{ token: NgCnafRadioGroup }, { token: NgCnafButtonLabel }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafRadio, selector: "[ngCnafButton][type=radio]", inputs: { name: "name", value: "value", disabled: "disabled" }, host: { listeners: { "change": "onChange()", "focus": "focused = true", "blur": "focused = false" }, properties: { "checked": "checked", "disabled": "disabled", "name": "nameAttr" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafRadio, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngCnafButton][type=radio]',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        '[checked]': 'checked',
                        '[disabled]': 'disabled',
                        '[name]': 'nameAttr',
                        '(change)': 'onChange()',
                        '(focus)': 'focused = true',
                        '(blur)': 'focused = false'
                    }
                }]
        }], ctorParameters: () => [{ type: NgCnafRadioGroup }, { type: NgCnafButtonLabel }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { name: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

/**
 * Cette directive permet de mettre le focus sur le premier champ invalide d'un formulaire.
 * Elle se déclenche au submit.
 */
class NgCnafFormFocusToFirstInvalidDirective {
    ngForm;
    el;
    /**
     * NgForm du html ou est placé la directive
     */
    formGroup;
    /**
     * offsetScrollY - Permet un décalage lors du scroll, par exemple quand il y a la barre d'étape
     */
    offsetScrollY;
    /**
     * Constructeur
     * @param ngForm Facultatif
     * @param el ElementRef
     */
    constructor(ngForm, el) {
        this.ngForm = ngForm;
        this.el = el;
    }
    /**
     * Place le focus sur l'élement HTML placé en paramètre
     * @param element HTMLElement
     * @param offsetScrollY number
     */
    static focusToElement(element, offsetScrollY) {
        if (element) {
            const distance = window.scrollY - Math.abs(element.getBoundingClientRect().top);
            setTimeout(() => {
                element.focus();
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: element.getBoundingClientRect().top - offsetScrollY + window.scrollY - 150
                });
            }, distance);
        }
    }
    /**
     * Permet de mettre le focus sur le premier input invalid du form
     * @param formGroup: NgForm
     * @param offsetScrollY: number - Permet un décalage lors du scroll, par exemple quand il y a la barre d'étape
     * @param element: ElementRef
     */
    static focusToFirstElementInvalid(formGroup, offsetScrollY, element) {
        setTimeout(() => {
            offsetScrollY = +offsetScrollY;
            if (formGroup && !formGroup.valid) {
                offsetScrollY = offsetScrollY ? offsetScrollY : 0;
                const formControlInvalid = $('input:visible.ng-invalid, select:visible.ng-invalid, textarea:visible.ng-invalid, ' +
                    'button:visible.ng-invalid, ng-cnaf-checkbox:visible.ng-invalid>button, [role="radiogroup"].ng-invalid input:first');
                if (formControlInvalid && formControlInvalid.length > 0) {
                    return NgCnafFormFocusToFirstInvalidDirective.focusToElement(formControlInvalid[0], offsetScrollY);
                }
                else {
                    // The first element is the global form and here we are looking for the first nested form
                    const formGroupInvalid = element.nativeElement.querySelectorAll('form.ng-invalid');
                    if (formGroupInvalid && formGroupInvalid.length) {
                        return NgCnafFormFocusToFirstInvalidDirective.focusToElement(formGroupInvalid[0], offsetScrollY);
                    }
                }
                return NgCnafFormFocusToFirstInvalidDirective.focusToElement(element.nativeElement, offsetScrollY);
            }
        });
    }
    /**
     *  Listener qui appelle la fonction focusToFirstElementInvalid
     * @param event Event
     */
    onSubmit(event) {
        event.preventDefault();
        if (this.formGroup) {
            NgCnafFormFocusToFirstInvalidDirective.focusToFirstElementInvalid(this.formGroup, this.offsetScrollY, this.el);
        }
        else if (this.ngForm) {
            NgCnafFormFocusToFirstInvalidDirective.focusToFirstElementInvalid(this.ngForm, this.offsetScrollY, this.el);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafFormFocusToFirstInvalidDirective, deps: [{ token: i1$4.NgForm, optional: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafFormFocusToFirstInvalidDirective, selector: "[ngCnafFormFocusToFirstInvalid]", inputs: { formGroup: "formGroup", offsetScrollY: "offsetScrollY" }, host: { listeners: { "submit": "onSubmit($event)" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafFormFocusToFirstInvalidDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[ngCnafFormFocusToFirstInvalid]' }]
        }], ctorParameters: () => [{ type: i1$4.NgForm, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }], propDecorators: { formGroup: [{
                type: Input
            }], offsetScrollY: [{
                type: Input
            }], onSubmit: [{
                type: HostListener,
                args: ['submit', ['$event']]
            }] } });

class NgCnafMaskDateDirective {
    element;
    maskService;
    /**
     *
     * @param element
     * @param maskService
     */
    constructor(element, maskService) {
        this.element = element;
        this.maskService = maskService;
    }
    onChange() {
        if (this.element && this.element.nativeElement) {
            this.element.nativeElement.value = this.maskService.applyMask(this.element.nativeElement.value, 'd0/M0/0000');
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafMaskDateDirective, deps: [{ token: i0.ElementRef }, { token: i1$5.NgxMaskService }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafMaskDateDirective, selector: "[ngCnafMaskDate]", host: { listeners: { "input": "onChange()" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafMaskDateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngCnafMaskDate]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$5.NgxMaskService }], propDecorators: { onChange: [{
                type: HostListener,
                args: ['input']
            }] } });

/**
 * Directive d'accessibilité qui ajoute un span avec comme contenu le title de l'élément
 * Modifie également l'attribut aria-describedby pour ajouter l'id de la span crée
 */
class NgCnafRequiredAccessibilityDirective {
    element;
    renderer;
    /**
     * Constructeur
     * @param element: ElementRef<HTMLElement>
     * @param renderer: Renderer2
     */
    constructor(element, renderer) {
        this.element = element;
        this.renderer = renderer;
    }
    /**
     * ngAfterViewInit
     */
    ngAfterViewInit() {
        // Récupération du titre
        const titre = this.element.nativeElement.title;
        // Si titre vide, on ne fait rien
        if (titre !== '') {
            // Récupération du titre de l'élément
            const id = this.element.nativeElement.id;
            // Modification du aria-describedby
            // @ts-expect-error refacto
            this.element.nativeElement.attributes['aria-describedby'].value =
                this.element.nativeElement.attributes['aria-describedby'].value + ' ' + id + '-help';
            // Création du span
            const span = this.renderer.createElement('span');
            const text = this.renderer.createText(titre);
            this.renderer.appendChild(span, text);
            this.renderer.addClass(span, 'sr-only');
            this.renderer.setProperty(span, 'id', id + '-help');
            this.renderer.appendChild(this.element.nativeElement.parentElement, span);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafRequiredAccessibilityDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafRequiredAccessibilityDirective, selector: "[ngCnafRequiredAccessibility]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafRequiredAccessibilityDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[ngCnafRequiredAccessibility]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }] });

/**
 *
 */
class NgCnafMessageErreurComponent {
    cdr;
    /**
     * text : contenu du message d'erreur
     */
    #text;
    /**
     * hide: indique si le message d'erreur doit être affiché
     */
    #hide = true;
    /**
     * id: id de l'élément p
     */
    #id;
    /**
     * set du message d'erreur
     */
    set text(value) {
        if (value !== this.#text) {
            this.#text = value;
            this.#hide = !value;
            this.cdr.detectChanges();
        }
    }
    /**
     * Constructeur
     * @param cdr: ChangeDetectorRef
     */
    constructor(cdr) {
        this.cdr = cdr;
    }
    get id() {
        return this.#id;
    }
    get hide() {
        return this.#hide;
    }
    get text() {
        return this.#text;
    }
    set id(id) {
        this.#id = id;
    }
    set hide(hide) {
        this.#hide = hide;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafMessageErreurComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: NgCnafMessageErreurComponent, selector: "ng-component", inputs: { text: "text" }, ngImport: i0, template: "<div role=\"alert\" class=\"has-error\">@if (!hide) {\n  <p class=\"help-block\" [id]=\"id\" [innerHtml]=\"text\" ></p>\n  }</div>@if (hide) {\n<p [id]=\"id\"></p>\n}", isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafMessageErreurComponent, decorators: [{
            type: Component,
            args: [{
                    template: `<div role="alert" class="has-error">@if (!hide) {
  <p class="help-block" [id]="id" [innerHtml]="text" ></p>
  }` +
                        `</div>@if (hide) {
<p [id]="id"></p>
}`,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { text: [{
                type: Input
            }] } });

/**
 * Directive permettant de simplifier la gestion des erreurs et intégrant les contraintes d'accessibilité
 * S'applique sur tous les élements définis dans le formControl
 */
let nextWindowId = 0;
class NgCnafMessageErreurDirective {
    controlDir;
    vcr;
    renderer;
    injector;
    appRef;
    /**
     * Objet contenant les messages d'erreur
     */
    static errorMessages = {};
    /**
     * ComponentRef du component NgCnafMessageErreurComponent
     */
    ref;
    /**
     * ViewContainerRef du component NgCnafMessageErreurComponent
     */
    container;
    /**
     * id de l'élement p contenant les erreurs
     */
    idComponentError;
    /**
     * Subscription du valueChanges de l'input
     */
    statusChangesObservable;
    touchedObservable;
    /**
     * Input qui permet d'indiquer que l'on souhaite activer la directive sur ce champ
     */
    ngCnafMessageErreur;
    /**
     * Input permettant de récupérer le controlName dans le cas d'un formControl
     */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    controlNameInput;
    /**
     * Variable qui sert pour l'input showError
     */
    #showErrorInput;
    /**
     * Vérifie si le component NgCnafMessageErreur est déjà présent dans l'élément en paramètre
     * @param element: any
     */
    static isErrorAlreadyExist(element) {
        const childNgCnafMessageErreur = [...element.children].filter((child) => child.nodeName === 'NG-COMPONENT');
        return childNgCnafMessageErreur && childNgCnafMessageErreur.length > 0;
    }
    /**
     * Input permettant d'activer ou de désactiver l'affichage des messages d'errurs
     */
    set showErrorInput(val) {
        this.#showErrorInput = val;
        if (this.control)
            this.showError(this.control, this.controlName);
    }
    /**
     *
     */
    get showErrorInput() {
        return this.#showErrorInput;
    }
    /**
     * Constructeur
     * @param controlDir: NgControl
     * @param vcr: ViewContainerRef
     * @param renderer: Renderer2
     * @param injector: Injector
     */
    constructor(controlDir, vcr, renderer, injector, appRef) {
        this.controlDir = controlDir;
        this.vcr = vcr;
        this.renderer = renderer;
        this.injector = injector;
        this.appRef = appRef;
        this.container = vcr;
    }
    /**
     * NgOnInit - Souscription du valueChanges du controle
     */
    ngOnInit() {
        // Test si la directive doit être activée
        if (this.ngCnafMessageErreur !== undefined) {
            // Set du aria-described du control
            let ariaDescribedby = this.container.element.nativeElement.attributes['aria-describedby']
                ? this.container.element.nativeElement.attributes['aria-describedby'].value
                : '';
            // Pour les radios et les checkbox, vu que le ng-cnaf-message-erreur est présent
            // sur tous les input, il faut s'assurer de mettre le meme id pour le aria-describedby
            if (this.container.element.nativeElement.type === 'radio') {
                const radioGroup = this.container.element.nativeElement.closest('div[role=radiogroup]');
                if (radioGroup) {
                    const selectErrorId = Array.from(radioGroup.querySelectorAll('input[type=radio]'))
                        // @ts-expect-error refacto
                        .flatMap((e) => e.attributes['aria-describedby'] && e.attributes['aria-describedby'].value.includes('error-')
                        ? e.attributes['aria-describedby'].value.split(' ')
                        : '')
                        .find((e) => e && e.startsWith('error-'));
                    if (selectErrorId)
                        this.idComponentError = selectErrorId;
                }
            }
            else if (this.container.element.nativeElement.type === 'checkbox') {
                const checkBoxGroup = this.container.element.nativeElement.closest('.ng-cnaf-checkbox');
                const selectErrorId = Array.from(checkBoxGroup.querySelectorAll('input[type=checkbox]'))
                    // @ts-expect-error refacto
                    .flatMap((e) => e.attributes['aria-describedby'] && e.attributes['aria-describedby'].value.includes('error-')
                    ? e.attributes['aria-describedby'].value.split(' ')
                    : '')
                    .find((e) => e && e.startsWith('error-'));
                if (selectErrorId)
                    this.idComponentError = selectErrorId;
            }
            if (!this.idComponentError)
                this.idComponentError = `error-${nextWindowId++}`;
            ariaDescribedby ? (ariaDescribedby = ariaDescribedby + ' ' + this.idComponentError) : (ariaDescribedby = this.idComponentError);
            this.renderer.setAttribute(this.container.element.nativeElement, 'aria-describedby', ariaDescribedby);
            this.setError('');
            if (this.control) {
                this.statusChangesObservable = this.control.statusChanges.subscribe(() => {
                    this.showError(this.control, this.controlName);
                });
                this.touchedObservable = extractTouchedChanges(this.control).subscribe(() => {
                    this.showError(this.control, this.controlName);
                });
            }
        }
    }
    /**
     * Permet d'afficher les erreurs si présence
     * @param control: AbstractControl
     * @param controlName: string
     */
    showError(control, controlName) {
        const controlErrors = control.errors;
        if (controlErrors && (this.showErrorInput === undefined || this.showErrorInput)) {
            const firstKey = Object.keys(controlErrors)[0];
            const message = this.getMessage(controlName, firstKey, controlErrors[firstKey]);
            this.setError(message);
        }
        else if (this.ref) {
            this.setError('');
        }
    }
    /**
     * get control
     */
    get control() {
        return this.controlDir.control;
    }
    /**
     * get controlName
     */
    get controlName() {
        // Cas d'un formControlName
        if (this.controlDir.name)
            return this.controlDir.name + '';
        // Cas d'un formControl ( le name est récupéré via l'input controlName)
        else
            return this.controlNameInput;
    }
    /**
     * Indique au composant NgCnafMessageErreurComponent les messages d'erreur à afficher
     * @param text: string
     */
    setError(text) {
        if (!this.ref) {
            // Cas checkbox - On injecte le component NgCnafMessageErreur dans le parent +2
            if (this.container.element.nativeElement.attributes.role &&
                this.container.element.nativeElement.attributes.role.value === 'checkbox') {
                const parentElement = this.container.element.nativeElement.closest('div[data-toggle="buttons"]').parentElement;
                this.createComponent(parentElement);
            }
            // Cas checkbox CNAF
            else if (this.container.element.nativeElement.attributes.type &&
                this.container.element.nativeElement.attributes.type.value === 'checkbox') {
                const parentElement = this.container.element.nativeElement.closest('div .ng-cnaf-checkbox').parentElement;
                this.createComponent(parentElement);
            }
            else if (this.container.element.nativeElement.nodeName === 'NG-CNAF-CHECKBOX') {
                /* Cas checkbox simple */
                const parentElement = this.container.element.nativeElement.closest('div');
                this.createComponent(parentElement);
            }
            else if (this.container.element.nativeElement.attributes.bsdatepicker !== undefined) {
                /* Cas Date picker */
                const parentElement = this.container.element.nativeElement.closest('div').parentElement;
                this.createComponent(parentElement);
            }
            else if (this.container.element.nativeElement.nodeName === 'SELECT') {
                /* Cas select */
                const component = this.vcr.createComponent(NgCnafMessageErreurComponent);
                this.ref = component;
                this.ref.instance.id = this.idComponentError;
            }
            else if (this.container.element.nativeElement.attributes.type.value === 'radio') {
                /* Cas bouton radio - parent pour arriver au fieldset */
                const parentElement = this.container.element.nativeElement.closest('fieldset');
                this.createComponent(parentElement);
            }
            else if (this.container.element.nativeElement.className.indexOf('input-group-end-cnaf') != -1) {
                const parentElement = this.container.element.nativeElement.closest('div');
                this.createComponent(parentElement);
            }
            else {
                const component = this.vcr.createComponent(NgCnafMessageErreurComponent);
                this.ref = component;
                this.ref.instance.id = this.idComponentError;
            }
        }
        if (this.ref)
            this.ref.instance.text = text;
    }
    /**
     * Création le composant NgComponentMessageErreur dans le htmlElement en paramètre
     * @param parentElement: HTMLElement
     */
    createComponent(parentElement) {
        if (!parentElement) {
            throw new Error("NgCnafMessageErreurDirective : Erreur d'initialisation de la directive sur le champ : " +
                this.controlName +
                ' - Vérifier la structure DOM');
        }
        else if (!NgCnafMessageErreurDirective.isErrorAlreadyExist(parentElement)) {
            this.ref = this.vcr.createComponent(NgCnafMessageErreurComponent, { injector: this.injector });
            parentElement.appendChild(this.ref.hostView.rootNodes[0]);
            this.ref.instance.id = this.idComponentError;
        }
    }
    /**
     * Retourne en fonction des erreurs du control, les libellés des messages d'erreurs associés </br>
     * Recherche en premier avec le type + le name ( ex : required + nameInput ), si pas de libellé perso, recherche ensuite libellé </br>
     * générique avec seulement le type ( ex : required ) </br>
     * Si aucun message trouvé throw d'une exception </br>
     * @param name: string
     * @param type: type
     * @param params: params
     */
    getMessage(name, type, params) {
        const specificType = type + name;
        // @ts-expect-error refacto
        if (typeof NgCnafMessageErreurDirective.errorMessages[specificType] === 'function') {
            // @ts-expect-error refacto
            return NgCnafMessageErreurDirective.errorMessages[specificType](params);
            // @ts-expect-error refacto
        }
        else if (typeof NgCnafMessageErreurDirective.errorMessages[type] !== 'function') {
            throw new Error("NgCnafMessageErreurDirective : Pas de message d'erreur défini pour la clé : " + type);
        }
        // @ts-expect-error refacto
        return NgCnafMessageErreurDirective.errorMessages[type](params);
    }
    /**
     * Permet d'afficher le message d'erreur pour les champs requis et
     * qu'on fait juste un blur sans modification de la valeur du champ
     */
    handleBlurEvent() {
        if (this.ngCnafMessageErreur !== undefined && this.control && (this.control.value === null || this.control.value === '')) {
            this.showError(this.control, this.controlName);
        }
    }
    /**
     * Implementation du ngOnDestroy
     */
    ngOnDestroy() {
        if (this.statusChangesObservable)
            this.statusChangesObservable.unsubscribe();
        if (this.touchedObservable)
            this.touchedObservable.unsubscribe();
        if (this.ref) {
            this.appRef.detachView(this.ref.hostView);
            this.ref.destroy();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafMessageErreurDirective, deps: [{ token: i1$4.NgControl }, { token: i0.ViewContainerRef }, { token: i0.Renderer2 }, { token: i0.Injector }, { token: i0.ApplicationRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafMessageErreurDirective, selector: "[formControlName],[formControl]", inputs: { ngCnafMessageErreur: "ngCnafMessageErreur", controlNameInput: ["controlName", "controlNameInput"], showErrorInput: ["showError", "showErrorInput"] }, host: { listeners: { "blur": "handleBlurEvent()" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafMessageErreurDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[formControlName],[formControl]'
                }]
        }], ctorParameters: () => [{ type: i1$4.NgControl }, { type: i0.ViewContainerRef }, { type: i0.Renderer2 }, { type: i0.Injector }, { type: i0.ApplicationRef }], propDecorators: { ngCnafMessageErreur: [{
                type: Input
            }], controlNameInput: [{
                type: Input,
                args: ['controlName']
            }], showErrorInput: [{
                type: Input,
                args: ['showError']
            }], handleBlurEvent: [{
                type: HostListener,
                args: ['blur']
            }] } });
/**
 * Extract a touched changed observable from an abstract control
 * @param control AbstractControl like object with markAsTouched method
 */
const extractTouchedChanges = (control) => {
    const prevMarkAsTouched = control.markAsTouched;
    const prevMarkAsUntouched = control.markAsUntouched;
    const touchedChanges$ = new Subject();
    function nextMarkAsTouched(...args) {
        touchedChanges$.next(true);
        prevMarkAsTouched.bind(control)(...args);
    }
    function nextMarkAsUntouched(...args) {
        touchedChanges$.next(false);
        prevMarkAsUntouched.bind(control)(...args);
    }
    control.markAsTouched = nextMarkAsTouched;
    control.markAsUntouched = nextMarkAsUntouched;
    return touchedChanges$;
};

/**
 * Modal avertissant que la session va expirer
 * Au bout de 30 secondes d'affichage, elle ouvre la modal avertissant que la connexion est dead
 */
class NgCnafModalSessionExpireComponent {
    bsModalRef;
    modalService;
    cnafAppConfigService;
    /**
     * Service CnafIdleService - passé en paramètre lors du show de la modal
     */
    cnafIdleService;
    /**
     * Stocke le setTimeout qui va avertir que la session est dead
     */
    idleOffset;
    /**
     * Bouton Continuer de la modal
     */
    buttonContinuer;
    /**
     * Configuration de la modal
     */
    CONFIG_MODAL = {
        backdrop: true,
        ignoreBackdropClick: true
    };
    /**
     * Constructeur
     * @param bsModalRef: BsModalRef
     * @param modalService: BsModalService
     * @param cnafAppConfigService: CnafAppConfigService
     */
    constructor(bsModalRef, modalService, cnafAppConfigService) {
        this.bsModalRef = bsModalRef;
        this.modalService = modalService;
        this.cnafAppConfigService = cnafAppConfigService;
    }
    /**
     * Lancement du setTimeout qui va gérer l'affichage de la modal avertissant que la session est dead
     */
    ngAfterViewInit() {
        if (this.cnafIdleService)
            this.idleOffset = setTimeout(() => {
                this.sessionDead();
            }, this.cnafIdleService.OFFSET_TIMEOUT);
        // Focus sur le bouton continuer par défaut
        setTimeout(() => {
            this.buttonContinuer.nativeElement.focus();
        });
    }
    /**
     * Fonction appelée au click du bouton Continuer
     */
    clickContinuer() {
        this.cnafIdleService.emitClickContinuer.emit();
        // Suppression du timer qui gère la modal session dead
        clearTimeout(this.idleOffset);
        // Appel fonction js du portail
        maintienSession();
        // Fermeture modal
        this.bsModalRef.hide();
        this.cnafIdleService.resetTimer();
    }
    /**
     * Fonction appelée au click sur le bouton Quitter
     */
    clickQuitter() {
        this.bsModalRef.hide();
        this.navigateToUrl(this.cnafAppConfigService.getRedirectDeconnexion());
    }
    /**
     * Navigation à l'url
     * @param url; string
     * @private
     */
    navigateToUrl(url) {
        window.location.href = url;
    }
    /**
     * Fonction appelée lors que le timer arrive à expiration
     */
    sessionDead() {
        // Fermeture de la modal
        this.bsModalRef.hide();
        // Ouverture modal de session dead
        this.modalService.show(NgCnafModalSessionDeadComponent, this.CONFIG_MODAL);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafModalSessionExpireComponent, deps: [{ token: i1$1.BsModalRef }, { token: i1$1.BsModalService }, { token: CnafAppConfigService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NgCnafModalSessionExpireComponent, selector: "ng-cnaf-modal-session-expire", viewQueries: [{ propertyName: "buttonContinuer", first: true, predicate: ["buttonContinuer"], descendants: true }], ngImport: i0, template: "<div class=\"modal-header\"><div role=\"heading\" aria-level=\"1\" class=\"texte-medium text-primary\" id=\"sessionModalExpire\">Voulez-vous continuer ?</div>    </div>    <div class=\"modal-body\">        <div class=\"row \">         <div class=\"col-sm-12\">           <p id=\"desc\">             Votre session va bient\u00F4t expirer.            <br>             Pour rester connect\u00E9, cliquez sur Continuer.             <br>             Pour vous d\u00E9connecter, cliquez sur Quitter.             </p>             <br>             <div class=\"float-end pull-right\">               <span class=\"form-group input-group\">            <button class=\"btn btn-form-cnaf btn-secondaire-cnaf me-2\" (click)=\"clickQuitter()\"  data-dismiss=\"modal\" data-bs-dismiss=\"modal\" aria-describedby=\"desc\">                Quitter            </button>                 <button class=\"btn btn-form-cnaf btn-majeur-cnaf\" (click)=\"clickContinuer()\"  data-dismiss=\"modal\" data-bs-dismiss=\"modal\" aria-describedby=\"desc\" #buttonContinuer>Continuer</button>                 </span>             </div>         </div>     </div>    </div>", isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafModalSessionExpireComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ng-cnaf-modal-session-expire',
                    template: '<div class="modal-header">' +
                        '<div role="heading" aria-level="1" class="texte-medium text-primary" id="sessionModalExpire">Voulez-vous continuer ?</div>' +
                        '    </div>' +
                        '    <div class="modal-body">' +
                        '        <div class="row ">' +
                        '         <div class="col-sm-12">' +
                        '           <p id="desc">' +
                        '             Votre session va bientôt expirer.' +
                        '            <br>' +
                        '             Pour rester connecté, cliquez sur Continuer.' +
                        '             <br>' +
                        '             Pour vous déconnecter, cliquez sur Quitter.' +
                        '             </p>' +
                        '             <br>' +
                        '             <div class="float-end pull-right">' +
                        '               <span class="form-group input-group">' +
                        '            <button class="btn btn-form-cnaf btn-secondaire-cnaf me-2" (click)="clickQuitter()"  data-dismiss="modal" data-bs-dismiss="modal" aria-describedby="desc">' +
                        '                Quitter' +
                        '            </button>' +
                        '                 <button class="btn btn-form-cnaf btn-majeur-cnaf" (click)="clickContinuer()"  data-dismiss="modal" data-bs-dismiss="modal" aria-describedby="desc" #buttonContinuer>Continuer</button>' +
                        '                 </span>' +
                        '             </div>' +
                        '         </div>' +
                        '     </div>' +
                        '    </div>'
                }]
        }], ctorParameters: () => [{ type: i1$1.BsModalRef }, { type: i1$1.BsModalService }, { type: CnafAppConfigService }], propDecorators: { buttonContinuer: [{
                type: ViewChild,
                args: ['buttonContinuer']
            }] } });

/**
 * CnafIdleService - Permet de gérer l'affichage de la popup de deconnexion
 */
class CnafIdleService {
    modalService;
    /**
     * Temps d'offset avant que la session expire
     */
    OFFSET_TIMEOUT = 30000;
    /**
     * Stocke le setTimeout affichant la popup
     */
    idleTimer;
    /**
     * TimeOut de la session
     */
    timeoutSessionMilliSecondes = 10 * 60 * 1000;
    /**
     * Event Emitter appelé lors du click sur le bouton continuer
     */
    emitClickContinuer = new EventEmitter();
    /**
     * Constructeur
     * @param modalService: BsModalService
     */
    constructor(modalService) {
        this.modalService = modalService;
        // Récupération du timeOutSession définie dans le portail
        if (typeof timeoutSessionSecondesCnaf !== 'undefined') {
            this.timeoutSessionMilliSecondes = timeoutSessionSecondesCnaf * 1000;
        }
    }
    /**
     * Démarrage du timer gérant la popup de deconnexion
     */
    startTimer() {
        this.idleTimer = setTimeout(() => {
            this.timerExpiring();
        }, this.timeoutSessionMilliSecondes - this.OFFSET_TIMEOUT);
    }
    /**
     * Arrêt du timer gérant la popup de déconnexion
     */
    stopTimer() {
        if (this.idleTimer) {
            clearTimeout(this.idleTimer);
        }
    }
    /**
     * Réinitialisation du timer gérant la popup de déconnexion
     */
    resetTimer() {
        this.stopTimer();
        this.startTimer();
    }
    /**
     * Fonction appelée lorsque le timer arrive à la fin
     */
    timerExpiring() {
        // On arrête le timer
        this.stopTimer();
        // Affichage de la modal d'expiration de session
        const config = {
            initialState: { cnafIdleService: this },
            backdrop: true,
            ignoreBackdropClick: true
        };
        this.modalService.show(NgCnafModalSessionExpireComponent, config);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafIdleService, deps: [{ token: i1$1.BsModalService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafIdleService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafIdleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.BsModalService }] });

/**
 * Configuration du routeur par défaut
 * - Appel du PageReady du thème
 * - Scroll réinitialisé à chaque changement de page ( sauf si passage de paramètre scroll à false)
 */
class CnafPopupDeconnexionConfigService {
    router;
    cnafIdleService;
    cnafAppConfigService;
    cnafTokenService;
    /**
     * Constructeur
     * @param router
     * @param cnafIdleService
     */
    constructor(router, cnafIdleService, cnafAppConfigService, cnafTokenService) {
        this.router = router;
        this.cnafIdleService = cnafIdleService;
        this.cnafAppConfigService = cnafAppConfigService;
        this.cnafTokenService = cnafTokenService;
    }
    /**
     * Configuration popup de deconnexion
     */
    async getConfigs() {
        const cnafIdleService = this.cnafIdleService;
        const router = this.router;
        const isUsagerOrPartenaire = this.isUsagerOrPartenaire();
        return lastValueFrom(new Observable((observer) => {
            // Test pour savoir si on doit activier la popup de deconnexion
            if (typeof clearTimeoutExpireSession !== 'function' &&
                isUsagerOrPartenaire &&
                typeof cnafPopupDeconnexion !== 'undefined' &&
                cnafPopupDeconnexion === true) {
                // Démarrage du timer qui gère l'affichage de la popup
                cnafIdleService.startTimer();
                if (router) {
                    // Reset du timer de session inactive à chaque changement de page
                    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
                        cnafIdleService.resetTimer();
                    });
                }
            }
            observer.next(true);
            observer.complete();
        }));
    }
    /**
     * Permet de savoir si le token a un scope partenaire ou usager
     */
    isUsagerOrPartenaire() {
        let isUsagerOrPartenaire = false;
        if (this.cnafAppConfigService.cnafAppConfigModel.tokenJWT) {
            const scopeToken = this.cnafTokenService.getTokenScope(this.cnafTokenService.decodeToken(this.cnafAppConfigService.cnafAppConfigModel.tokenJWT));
            if (scopeToken === CnafScopeToken.Usagers || scopeToken === CnafScopeToken.Partenaires) {
                isUsagerOrPartenaire = true;
            }
        }
        return isUsagerOrPartenaire;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafPopupDeconnexionConfigService, deps: [{ token: i1$3.Router, optional: true }, { token: CnafIdleService }, { token: CnafAppConfigService }, { token: CnafTokenService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafPopupDeconnexionConfigService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnafPopupDeconnexionConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$3.Router, decorators: [{
                    type: Optional
                }] }, { type: CnafIdleService }, { type: CnafAppConfigService }, { type: CnafTokenService }] });

/**
 * Module NgCnafCommonsModule
 */
class NgCnafCommonsModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafCommonsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: NgCnafCommonsModule, declarations: [NgCnafAideComponent,
            NgCnafCheckboxComponent,
            NgCnafCheckboxComponent,
            NgCnafBarreEtapeComponent,
            NgCnafAtTagDirective,
            NgCnafStatsSidDirective,
            NgCnafTelechargementPdfDirective,
            NgCnafFocusDirective,
            NgCnafTelechargementPdfModalComponent,
            NgCnafHandlerKeyAccessibility,
            NgCnafFormFocusToFirstInvalidDirective,
            NgCnafRequiredAccessibilityDirective,
            NgCnafMessageErreurDirective,
            NgCnafMessageErreurComponent,
            NgCnafRadio,
            NgCnafRadioGroup,
            NgCnafButtonLabel,
            NgCnafCheckbox2Component,
            NgCnafModalSessionExpireComponent,
            NgCnafModalSessionDeadComponent,
            NgCnafBarreProgressionComponent,
            NgCnafMultiselectComponent,
            ListFilterPipe,
            ClickOutsideDirective,
            FocusOutsideDirective,
            NgCnafMaskDateDirective], imports: [CommonModule, FormsModule, i4.PopoverModule, i2$1.BsDatepickerModule, i1$1.ModalModule], exports: [NgCnafAideComponent,
            NgCnafCheckboxComponent,
            NgCnafBarreEtapeComponent,
            NgCnafBarreProgressionComponent,
            NgCnafMultiselectComponent,
            BsDatepickerModule,
            NgCnafAtTagDirective,
            NgCnafStatsSidDirective,
            NgCnafTelechargementPdfDirective,
            NgCnafFocusDirective,
            NgCnafTelechargementPdfModalComponent,
            NgCnafHandlerKeyAccessibility,
            NgCnafFormFocusToFirstInvalidDirective,
            NgCnafRequiredAccessibilityDirective,
            NgCnafMessageErreurDirective,
            NgCnafRadio,
            NgCnafRadioGroup,
            NgCnafButtonLabel,
            NgCnafCheckbox2Component,
            HttpClientModule,
            NgCnafMaskDateDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafCommonsModule, providers: [
            ListFilterPipe,
            {
                provide: HTTP_INTERCEPTORS,
                useClass: CnafTokenInterceptor,
                multi: true
            },
            { provide: APP_INITIALIZER, useFactory: loadAppConfig, deps: [CnafAppConfigLoaderService], multi: true },
            {
                provide: APP_BOOTSTRAP_LISTENER,
                useFactory: loadAppBootstrapListener,
                deps: [CnafRouterConfigService, CnafPopupDeconnexionConfigService],
                multi: true
            },
            { provide: BsDatepickerConfig, useFactory: getDatepickerConfig },
            { provide: BsLocaleService, useFactory: getLocaleService },
            provideNgxMask()
        ], imports: [CommonModule, FormsModule, PopoverModule.forRoot(), BsDatepickerModule.forRoot(), ModalModule.forRoot(), BsDatepickerModule,
            HttpClientModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NgCnafCommonsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NgCnafAideComponent,
                        NgCnafCheckboxComponent,
                        NgCnafCheckboxComponent,
                        NgCnafBarreEtapeComponent,
                        NgCnafAtTagDirective,
                        NgCnafStatsSidDirective,
                        NgCnafTelechargementPdfDirective,
                        NgCnafFocusDirective,
                        NgCnafTelechargementPdfModalComponent,
                        NgCnafHandlerKeyAccessibility,
                        NgCnafFormFocusToFirstInvalidDirective,
                        NgCnafRequiredAccessibilityDirective,
                        NgCnafMessageErreurDirective,
                        NgCnafMessageErreurComponent,
                        NgCnafRadio,
                        NgCnafRadioGroup,
                        NgCnafButtonLabel,
                        NgCnafCheckbox2Component,
                        NgCnafModalSessionExpireComponent,
                        NgCnafModalSessionDeadComponent,
                        NgCnafBarreProgressionComponent,
                        NgCnafMultiselectComponent,
                        ListFilterPipe,
                        ClickOutsideDirective,
                        FocusOutsideDirective,
                        NgCnafMaskDateDirective
                    ],
                    imports: [CommonModule, FormsModule, PopoverModule.forRoot(), BsDatepickerModule.forRoot(), ModalModule.forRoot()],
                    // eslint-disable-next-line max-len
                    exports: [
                        NgCnafAideComponent,
                        NgCnafCheckboxComponent,
                        NgCnafBarreEtapeComponent,
                        NgCnafBarreProgressionComponent,
                        NgCnafMultiselectComponent,
                        BsDatepickerModule,
                        NgCnafAtTagDirective,
                        NgCnafStatsSidDirective,
                        NgCnafTelechargementPdfDirective,
                        NgCnafFocusDirective,
                        NgCnafTelechargementPdfModalComponent,
                        NgCnafHandlerKeyAccessibility,
                        NgCnafFormFocusToFirstInvalidDirective,
                        NgCnafRequiredAccessibilityDirective,
                        NgCnafMessageErreurDirective,
                        NgCnafRadio,
                        NgCnafRadioGroup,
                        NgCnafButtonLabel,
                        NgCnafCheckbox2Component,
                        HttpClientModule,
                        NgCnafMaskDateDirective
                    ],
                    providers: [
                        ListFilterPipe,
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: CnafTokenInterceptor,
                            multi: true
                        },
                        { provide: APP_INITIALIZER, useFactory: loadAppConfig, deps: [CnafAppConfigLoaderService], multi: true },
                        {
                            provide: APP_BOOTSTRAP_LISTENER,
                            useFactory: loadAppBootstrapListener,
                            deps: [CnafRouterConfigService, CnafPopupDeconnexionConfigService],
                            multi: true
                        },
                        { provide: BsDatepickerConfig, useFactory: getDatepickerConfig },
                        { provide: BsLocaleService, useFactory: getLocaleService },
                        provideNgxMask()
                    ]
                }]
        }] });
/**
 * Fonction pour l'init du module - Init config technique du module
 */
function loadAppConfig(cnafAppConfigLoader) {
    const retour = () => cnafAppConfigLoader.getConfigs();
    return retour;
}
/**
 * Fonction loadAppBootstrapListener - Initialisation du routeur et de la popup de deconnexion
 * @param cnafRouterConfig : CnafRouterConfigService
 * @param cnafPopupService : CnafPopupDeconnexionConfigService
 */
function loadAppBootstrapListener(cnafRouterConfig, cnafPopupService) {
    const retour = () => Promise.all([cnafPopupService.getConfigs(), cnafRouterConfig.getConfigs()]);
    return retour;
}
/**
 * Configuration par défaut du DatePicker - Format JJ/MM/AAAA
 */
function getDatepickerConfig() {
    return Object.assign(new BsDatepickerConfig(), {
        dateInputFormat: 'DD/MM/YYYY',
        showWeekNumbers: false
    });
}
/**
 * Paramétrage français calendrier ngx-bootstrap
 */
function getLocaleService() {
    // Suppression du message "Invalid Date" par défaut
    frLocale.invalidDate = '';
    defineLocale('fr', frLocale);
    const bsLocalService = new BsLocaleService();
    bsLocalService.use('fr');
    return bsLocalService;
}

/*
 * Public API Surface of ng-cnaf-commons
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CNAF_APP_CONFIG, CnafAppConfigService, CnafAtTagService, CnafIdleService, CnafStatsSidService, CnafTokenService, CnafUserService, DROPDOWN_CONTROL_VALUE_ACCESSOR, NgCnafAideComponent, NgCnafAtTagDirective, NgCnafBarreEtapeComponent, NgCnafBarreProgressionComponent, NgCnafButtonLabel, NgCnafCheckbox2Component, NgCnafCheckboxComponent, NgCnafCommonsModule, NgCnafFocusDirective, NgCnafFormFocusToFirstInvalidDirective, NgCnafHandlerKeyAccessibility, NgCnafMaskDateDirective, NgCnafMessageErreurComponent, NgCnafMessageErreurDirective, NgCnafMultiselectComponent, NgCnafRadio, NgCnafRadioGroup, NgCnafRequiredAccessibilityDirective, NgCnafStatsSidDirective, NgCnafTelechargementPdfDirective, NgCnafTelechargementPdfModalComponent, extractTouchedChanges, getDatepickerConfig, getLocaleService, loadAppBootstrapListener, loadAppConfig };
